const sevenToneScaleChange = {
  ionian: {
    1: {
      ArrowUp: {
        x: 6,
        y: 3,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#fff",
        degree: "b4",
        degreeColor: "#FF7F00",
        formulae: [1, 2, 4, 5, 7, 9, 11],
        formulaeOriginal: ["1", "2", "4", "5", "7", "9", "A"],
        numbers: ["1", "b2", "b3", "b4", "b5", "b6", "b7"],
        underlinedNumbers: ["1", "b5"],
        doubleUnderlineNumbers: ["b4", "b7"],
      },
      ArrowDown: null,
    },
    2: {
      ArrowUp: {
        x: 0,
        y: 0,
        prevDegree: "1.",
        name: "ionian",
        nameColor: "#FF0000",
        formulae: [1, 3, 5, 6, 8, 10, 12],
        formulaeOriginal: ["1", "3", "5", "6", "8", "0", "B"],
        numbers: ["1", "2", "3", "4", "5", "6", "7"],
        underlinedNumbers: ["4", "7"],
        // doubleUnderlineNumbers: ["2", "3"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 0,
        y: 0,
        prevDegree: "1.",
        name: "ionian",
        nameColor: "#FF0000",
        formulae: [1, 3, 5, 6, 8, 10, 12],
        formulaeOriginal: ["1", "3", "5", "6", "8", "0", "B"],
        numbers: ["1", "2", "3", "4", "5", "6", "7"],
        underlinedNumbers: ["4", "7"],
        // doubleUnderlineNumbers: ["2", "3"],
        chromaticFormula: true,
      },
    },
    3: {
      ArrowUp: null,
      ArrowDown: {
        x: 0,
        y: 3,
        prevDegree: "1.",
        name: "ionian",
        nameColor: "#FF0000",
        degree: "b3",
        degreeColor: "#FFFF00",
        formulae: [1, 3, 4, 6, 8, 10, 12],
        formulaeOriginal: ["1", "3", "4", "6", "8", "0", "B"],
        numbers: ["1", "2", "b3", "4", "5", "6", "7"],
        doubleUnderlineNumbers: ["b3", "6"],
        underlinedNumbers: ["4", "7"],
      },
    },
    4: {
      ArrowUp: {
        x: 3,
        y: 0,
        prevDegree: "4.",
        name: "lydian",
        nameColor: "#ff00b7",
        formulae: [1, 3, 5, 7, 8, 10, 12],
        formulaeOriginal: ["1", "3", "5", "7", "8", "0", "B"],
        numbers: ["1", "2", "3", "♯4", "5", "6", "7"],
        underlinedNumbers: ["1", "♯4"],
      },
      ArrowDown: null,
    },
    5: {
      ArrowUp: {
        x: 2,
        y: 2,
        prevDegree: "b3.",
        name: "Ionian",
        nameColor: "#FF0000",
        degree: "♯5",
        degreeColor: "#00FF00",
        formulae: [1, 3, 5, 6, 9, 10, 12],
        formulaeOriginal: ["1", "3", "5", "6", "9", "0", "B"],
        numbers: ["1", "2", "3", "4", "♯5", "6", "7"],
        doubleUnderlineNumbers: ["4", "7"],
        underlinedNumbers: ["2", "♯5"],
      },
      ArrowDown: {
        x: 0,
        y: 0,
        prevDegree: "1.",
        name: "ionian",
        nameColor: "#FF0000",
        formulae: [1, 3, 5, 6, 8, 10, 12],
        formulaeOriginal: ["1", "3", "5", "6", "8", "0", "B"],
        numbers: ["1", "2", "3", "4", "5", "6", "7"],
        underlinedNumbers: ["4", "7"],
        chromaticFormula: true,
      },
    },
    6: {
      ArrowUp: {
        x: 0,
        y: 0,
        prevDegree: "1.",
        name: "ionian",
        nameColor: "#FF0000",
        formulae: [1, 3, 5, 6, 8, 10, 12],
        formulaeOriginal: ["1", "3", "5", "6", "8", "0", "B"],
        numbers: ["1", "2", "3", "4", "5", "6", "7"],
        underlinedNumbers: ["4", "7"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 0,
        y: 1,
        prevDegree: "1.",
        name: "ionian",
        nameColor: "#FF0000",
        degree: "b6",
        degreeColor: "#00FF00",
        formulae: [1, 3, 5, 6, 8, 9, 12],
        formulaeOriginal: ["1", "3", "5", "6", "8", "9", "B"],
        numbers: ["1", "2", "3", "4", "5", "b6", "7"],
        doubleUnderlineNumbers: ["2", "b6"],
        underlinedNumbers: ["4", "7"],
      },
    },
    7: {
      ArrowUp: null,
      ArrowDown: {
        x: 4,
        y: 0,
        prevDegree: "5.",
        name: "mixo",
        nameColor: "#FF7F00",
        formulae: [1, 3, 5, 6, 8, 10, 11],
        formulaeOriginal: ["1", "3", "5", "6", "8", "0", "A"],
        numbers: ["1", "2", "3", "4", "5", "6", "b7"],
        underlinedNumbers: ["b7"],
      },
    },
  },
  dorian: {
    1: {
      ArrowUp: {
        x: 1,
        y: 0,
        prevDegree: "2.",
        name: "dorian",
        nameColor: "#FFFF00",
        formulae: [1, 3, 4, 6, 8, 10, 11],
        formulaeOriginal: ["1", "3", "4", "6", "8", "0", "A"],
        numbers: ["1", "2", "b3", "4", "5", "6", "b7"],
        underlinedNumbers: ["b3", "6"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 1,
        y: 0,
        prevDegree: "2.",
        name: "dorian",
        nameColor: "#FFFF00",
        formulae: [1, 3, 4, 6, 8, 10, 11],
        formulaeOriginal: ["1", "3", "4", "6", "8", "0", "A"],
        numbers: ["1", "2", "b3", "4", "5", "6", "b7"],
        underlinedNumbers: ["b3", "6"],
        chromaticFormula: true,
      },
    },
    2: {
      ArrowUp: null,
      ArrowDown: {
        x: 1,
        y: 3,
        prevDegree: "2.",
        name: "dorian",
        nameColor: "#FFFF00",
        degree: "b2",
        degreeColor: "#1e62ff",
        formulae: [1, 2, 4, 6, 8, 10, 11],
        formulaeOriginal: ["1", "3", "4", "6", "8", "0", "B"],
        numbers: ["1", "2", "b3", "4", "b5", "6", "b7"],
        doubleUnderlineNumbers: ["2", "b5"],
        underlinedNumbers: ["b3", "6"],
      },
    },
    3: {
      ArrowUp: {
        x: 4,
        y: 0,
        prevDegree: "5.",
        name: "mixo",
        nameColor: "#FF7F00",
        formulae: [1, 3, 5, 6, 8, 10, 11],
        formulaeOriginal: ["1", "3", "5", "6", "8", "0", "A"],
        numbers: ["1", "2", "3", "4", "5", "6", "b7"],
        underlinedNumbers: ["3", "b7"],
      },
      ArrowDown: null,
    },
    4: {
      ArrowUp: {
        x: 3,
        y: 2,
        prevDegree: "4.",
        name: "dorian",
        nameColor: "#FFFF00",
        degree: "♯4",
        degreeColor: "#ff00b7",
        formulae: [1, 3, 4, 7, 8, 10, 11],
        formulaeOriginal: ["1", "3", "4", "7", "8", "0", "A"],
        numbers: ["1", "2", "b3", "♯4", "5", "6", "b7"],
        underlinedNumbers: ["1", "♯4"],
        doubleUnderlineNumbers: ["b3", "6"],
      },
      ArrowDown: {
        x: 1,
        y: 0,
        prevDegree: "2.",
        name: "dorian",
        nameColor: "#FFFF00",
        formulae: [1, 3, 4, 6, 8, 10, 11],
        formulaeOriginal: ["1", "3", "4", "6", "8", "0", "A"],
        numbers: ["1", "2", "b3", "4", "5", "6", "b7"],
        underlinedNumbers: ["b3", "6"],
        chromaticFormula: true,
      },
    },
    5: {
      ArrowUp: {
        x: 1,
        y: 0,
        prevDegree: "2.",
        name: "dorian",
        nameColor: "#FFFF00",
        formulae: [1, 3, 4, 6, 8, 10, 11],
        formulaeOriginal: ["1", "3", "4", "6", "8", "0", "A"],
        numbers: ["1", "2", "b3", "4", "5", "6", "b7"],
        underlinedNumbers: ["b3", "6"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 1,
        y: 1,
        prevDegree: "2.",
        name: "dorian",
        nameColor: "#FFFF00",
        degree: "b5",
        degreeColor: "#1e62ff",
        formulae: [1, 3, 4, 6, 7, 10, 11],
        formulaeOriginal: ["1", "3", "4", "6", "7", "0", "A"],
        numbers: ["1", "2", "b3", "4", "b5", "6", "b7"],
        doubleUnderlineNumbers: ["1", "b5"],
        underlinedNumbers: ["b3", "6"],
      },
    },
    6: {
      ArrowUp: null,
      ArrowDown: {
        x: 5,
        y: 0,
        prevDegree: "6.",
        name: "aeolian",
        nameColor: "#00FF00",
        formulae: [1, 3, 4, 6, 8, 9, 11],
        formulaeOriginal: ["1", "3", "4", "6", "8", "9", "A"],
        numbers: ["1", "2", "b3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["2", "b6"],
      },
    },
    7: {
      ArrowUp: {
        x: 0,
        y: 3,
        prevDegree: "1.",
        name: "ionian",
        nameColor: "#FF0000",
        degree: "b3",
        degreeColor: "#FFFF00",
        formulae: [1, 3, 4, 6, 8, 10, 12],
        formulaeOriginal: ["1", "3", "4", "6", "8", "0", "B"],
        numbers: ["1", "2", "b3", "4", "5", "6", "7"],
        doubleUnderlineNumbers: ["b3", "6"],
        underlinedNumbers: ["4", "7"],
      },
      ArrowDown: null,
    },
  },
  phrygian: {
    1: {
      ArrowUp: null,
      ArrowDown: {
        x: 2,
        y: 3,
        prevDegree: "b3.",
        name: "lydian",
        nameColor: "#fff",
        degree: "♯5",
        degreeColor: "#00FF00",
        // secondDegree: "♯5",
        // secondDegreeColor: "#fff",
        formulae: [1, 3, 5, 7, 9, 10, 12],
        formulaeOriginal: ["1", "3", "5", "7", "9", "0", "B"],
        numbers: ["1", "2", "3", "♯4", "♯5", "6", "7"],
        doubleUnderlineNumbers: ["1", "♯4"],
        underlinedNumbers: ["2", "♯5"],
      },
    },
    2: {
      ArrowUp: {
        y: 0,
        prevDegree: "6.",
        name: "aeolian",
        nameColor: "#00FF00",
        formulae: [1, 3, 4, 6, 8, 9, 11],
        formulaeOriginal: ["1", "3", "4", "6", "8", "9", "A"],
        numbers: ["1", "2", "b3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["2", "b6"],
      },
      ArrowDown: null,
    },
    3: {
      ArrowUp: {
        x: 4,
        y: 2,
        prevDegree: "5.",
        name: "phrygian",
        nameColor: "#1e62ff",
        degree: "♮3",
        degreeColor: "#ff7f00",
        formulae: [1, 2, 5, 6, 8, 9, 11],
        formulaeOriginal: ["1", "2", "5", "6", "8", "9", "A"],
        numbers: ["1", "b2", "3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["3", "b7"],
        doubleUnderlineNumbers: ["b2", "5"],
      },
      ArrowDown: {
        x: 2,
        y: 0,
        prevDegree: "3.",
        name: "phrygian",
        nameColor: "#1e62ff",
        formulae: [1, 2, 4, 6, 8, 9, 11],
        formulaeOriginal: ["1", "2", "4", "6", "8", "9", "A"],
        numbers: ["1", "b2", "b3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["b2", "5"],
        chromaticFormula: true,
      },
    },
    4: {
      ArrowUp: {
        x: 2,
        y: 0,
        prevDegree: "3.",
        name: "phrygian",
        nameColor: "#1e62ff",
        formulae: [1, 2, 4, 6, 8, 9, 11],
        formulaeOriginal: ["1", "2", "4", "6", "8", "9", "A"],
        numbers: ["1", "b2", "b3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["b2", "5"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 2,
        y: 1,
        prevDegree: "3.",
        name: "phrygian",
        nameColor: "#1e62ff",
        degree: "b4",
        degreeColor: "#FF7F00",
        formulae: [1, 2, 4, 5, 8, 9, 11],
        formulaeOriginal: ["1", "2", "4", "5", "8", "9", "A"],
        numbers: ["1", "b2", "b3", "b4", "5", "b6", "b7"],
        underlinedNumbers: ["b2", "5"],
        doubleUnderlineNumbers: ["b4", "b7"],
      },
    },
    5: {
      ArrowUp: null,
      ArrowDown: {
        x: 6,
        y: 0,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#AE96FF",
        formulae: [1, 2, 4, 6, 7, 9, 11],
        formulaeOriginal: ["1", "2", "4", "6", "7", "9", "A"],
        numbers: ["1", "b2", "b3", "4", "b5", "b6", "b7"],
        underlinedNumbers: ["1", "b5"],
      },
    },
    6: {
      ArrowUp: {
        x: 1,
        y: 3,
        prevDegree: "2.",
        name: "dorian",
        nameColor: "#FFFF00",
        degree: "b2",
        degreeColor: "#1e62ff",
        formulae: [1, 2, 4, 6, 8, 10, 11],
        formulaeOriginal: ["1", "3", "4", "6", "8", "0", "B"],
        numbers: ["1", "2", "b3", "4", "b5", "6", "b7"],
        doubleUnderlineNumbers: ["2", "b5"],
        underlinedNumbers: ["b3", "6"],
      },
      ArrowDown: null,
    },
    7: {
      ArrowUp: {
        x: 2,
        y: 0,
        prevDegree: "3.",
        name: "phrygian",
        nameColor: "#1e62ff",
        formulae: [1, 2, 4, 6, 8, 9, 11],
        formulaeOriginal: ["1", "2", "4", "6", "8", "9", "A"],
        numbers: ["1", "b2", "b3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["b2", "5"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 2,
        y: 0,
        prevDegree: "3.",
        name: "phrygian",
        nameColor: "#1e62ff",
        formulae: [1, 2, 4, 6, 8, 9, 11],
        formulaeOriginal: ["1", "2", "4", "6", "8", "9", "A"],
        numbers: ["1", "b2", "b3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["b2", "5"],
        chromaticFormula: true,
      },
    },
  },
  lydian: {
    1: {
      ArrowUp: {
        x: 6,
        y: 0,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#AE96FF",
        formulae: [1, 2, 4, 6, 7, 9, 11],
        formulaeOriginal: ["1", "2", "4", "6", "7", "9", "A"],
        numbers: ["1", "b2", "b3", "4", "b5", "b6", "b7"],
        underlinedNumbers: ["1", "b5"],
      },
      ArrowDown: null,
    },
    2: {
      ArrowUp: {
        x: 5,
        y: 2,
        prevDegree: "b6.",
        name: "lydian",
        nameColor: "#ff00b7",
        degree: "♯2",
        degreeColor: "#FFFF00",
        formulae: [1, 4, 5, 7, 8, 10, 12],
        formulaeOriginal: ["1", "4", "5", "7", "8", "0", "B"],
        numbers: ["1", "♯2", "3", "♯4", "5", "6", "7"],
        doubleUnderlineNumbers: ["1", "♯4"],
        underlinedNumbers: ["♯2", "6"],
      },
      ArrowDown: {
        x: 3,
        y: 0,
        prevDegree: "4.",
        name: "lydian",
        nameColor: "#ff00b7",
        formulae: [1, 3, 5, 7, 8, 10, 12],
        formulaeOriginal: ["1", "3", "5", "7", "8", "0", "B"],
        numbers: ["1", "2", "3", "♯4", "5", "6", "7"],
        underlinedNumbers: ["1", "♯4"],
        chromaticFormula: true,
      },
    },
    3: {
      ArrowUp: {
        x: 3,
        y: 0,
        prevDegree: "4.",
        name: "lydian",
        nameColor: "#ff00b7",
        formulae: [1, 3, 5, 7, 8, 10, 12],
        formulaeOriginal: ["1", "3", "5", "7", "8", "0", "B"],
        numbers: ["1", "2", "3", "♯4", "5", "6", "7"],
        underlinedNumbers: ["1", "♯4"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 3,
        y: 1,
        prevDegree: "4.",
        name: "lydian",
        nameColor: "#ff00b7",
        degree: "b3",
        degreeColor: "#FFFF00",
        formulae: [1, 3, 4, 7, 8, 10, 12],
        formulaeOriginal: ["1", "3", "4", "7", "8", "0", "B"],
        numbers: ["1", "2", "b3", "♯4", "5", "6", "7"],
        underlinedNumbers: ["1", "♯4"],
        doubleUnderlineNumbers: ["b3", "6"],
      },
    },
    4: {
      ArrowUp: null,
      ArrowDown: {
        x: 0,
        y: 0,
        prevDegree: "1.",
        name: "ionian",
        nameColor: "#FF0000",
        formulae: [1, 3, 5, 6, 8, 10, 12],
        formulaeOriginal: ["1", "3", "5", "6", "8", "0", "B"],
        numbers: ["1", "2", "3", "4", "5", "6", "7"],
        underlinedNumbers: ["4", "7"],
      },
    },
    5: {
      ArrowUp: {
        x: 2,
        y: 3,
        prevDegree: "b3.",
        name: "lydian",
        nameColor: "#fff",
        degree: "♯5",
        degreeColor: "#00FF00",
        // secondDegree: "♯5",
        // secondDegreeColor: "#fff",
        formulae: [1, 3, 5, 7, 9, 10, 12],
        formulaeOriginal: ["1", "3", "5", "7", "9", "0", "B"],
        numbers: ["1", "2", "3", "♯4", "♯5", "6", "7"],
        doubleUnderlineNumbers: ["1", "♯4"],
        underlinedNumbers: ["2", "♯5"],
      },
      ArrowDown: null,
    },
    6: {
      ArrowUp: {
        x: 3,
        y: 0,
        prevDegree: "4.",
        name: "lydian",
        nameColor: "#ff00b7",
        formulae: [1, 3, 5, 7, 8, 10, 12],
        formulaeOriginal: ["1", "3", "5", "7", "8", "0", "B"],
        numbers: ["1", "2", "3", "♯4", "5", "6", "7"],
        underlinedNumbers: ["1", "♯4"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 3,
        y: 0,
        prevDegree: "4.",
        name: "lydian",
        nameColor: "#ff00b7",
        formulae: [1, 3, 5, 7, 8, 10, 12],
        formulaeOriginal: ["1", "3", "5", "7", "8", "0", "B"],
        numbers: ["1", "2", "3", "♯4", "5", "6", "7"],
        underlinedNumbers: ["1", "♯4"],
        chromaticFormula: true,
      },
    },
    7: {
      ArrowUp: null,
      ArrowDown: {
        x: 3,
        y: 3,
        prevDegree: "4.",
        name: "lydian",
        nameColor: "#ff00b7",
        degree: "b7",
        degreeColor: "#FF7F00",
        formulae: [1, 3, 5, 7, 8, 10, 11],
        formulaeOriginal: ["1", "3", "5", "7", "8", "0", "A"],
        numbers: ["1", "2", "3", "♯4", "5", "6", "b7"],
        underlinedNumbers: ["1", "♯4"],
        doubleUnderlineNumbers: ["3", "b7"],
      },
    },
  },
  mixo: {
    1: {
      ArrowUp: {
        x: 6,
        y: 2,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#fff",
        degree: "b4",
        degreeColor: "#fff",
        secondDegree: "bb7",
        secondDegreeColor: "#FFFF00",
        text: "(Altered bb7)",
        formulae: [1, 2, 4, 5, 7, 9, 10],
        formulaeOriginal: ["1", "2", "4", "5", "7", "9", "0"],
        numbers: ["1", "b2", "b3", "b4", "b5", "b6", "bb7"],
        underlinedNumbers: ["1", "b5"],
        doubleUnderlineNumbers: ["b3", "bb7"],
      },
      ArrowDown: {
        x: 4,
        y: 0,
        prevDegree: "5.",
        name: "mixo",
        nameColor: "#FF7F00",
        formulae: [1, 3, 5, 6, 8, 10, 11],
        formulaeOriginal: ["1", "3", "5", "6", "8", "0", "A"],
        numbers: ["1", "2", "3", "4", "5", "6", "b7"],
        underlinedNumbers: ["3", "b7"],
        chromaticFormula: true,
      },
    },
    2: {
      ArrowUp: {
        x: 4,
        y: 0,
        prevDegree: "5.",
        name: "mixo",
        nameColor: "#FF7F00",
        formulae: [1, 3, 5, 6, 8, 10, 11],
        formulaeOriginal: ["1", "3", "5", "6", "8", "0", "A"],
        numbers: ["1", "2", "3", "4", "5", "6", "b7"],
        underlinedNumbers: ["3", "b7"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 4,
        y: 1,
        prevDegree: "5.",
        name: "mixo",
        nameColor: "#FF7F00",
        degree: "b2",
        degreeColor: "#1e62ff",
        formulae: [1, 2, 5, 6, 8, 10, 11],
        formulaeOriginal: ["1", "2", "5", "6", "8", "0", "A"],
        numbers: ["1", "b2", "3", "4", "5", "6", "b7"],
        doubleUnderlineNumbers: ["b2", "5"],
        underlinedNumbers: ["3", "b7"],
      },
    },
    3: {
      ArrowUp: null,
      ArrowDown: {
        x: 1,
        y: 0,
        prevDegree: "2.",
        name: "dorian",
        nameColor: "#FFFF00",
        formulae: [1, 3, 4, 6, 8, 10, 11],
        formulaeOriginal: ["1", "3", "4", "6", "8", "0", "A"],
        numbers: ["1", "2", "b3", "4", "5", "6", "b7"],
        underlinedNumbers: ["b3", "6"],
      },
    },
    4: {
      ArrowUp: {
        x: 3,
        y: 3,
        prevDegree: "4.",
        name: "lydian",
        nameColor: "#ff00b7",
        degree: "b7",
        degreeColor: "#FF7F00",
        formulae: [1, 3, 5, 7, 8, 10, 11],
        formulaeOriginal: ["1", "3", "5", "7", "8", "0", "A"],
        numbers: ["1", "2", "3", "♯4", "5", "6", "b7"],
        underlinedNumbers: ["1", "♯4"],
        doubleUnderlineNumbers: ["3", "b7"],
      },
      ArrowDown: null,
    },
    5: {
      ArrowUp: {
        x: 4,
        y: 0,
        prevDegree: "5.",
        name: "mixo",
        nameColor: "#FF7F00",
        formulae: [1, 3, 5, 6, 8, 10, 11],
        formulaeOriginal: ["1", "3", "5", "6", "8", "0", "A"],
        numbers: ["1", "2", "3", "4", "5", "6", "b7"],
        underlinedNumbers: ["3", "b7"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 4,
        y: 0,
        prevDegree: "5.",
        name: "mixo",
        nameColor: "#FF7F00",
        formulae: [1, 3, 5, 6, 8, 10, 11],
        formulaeOriginal: ["1", "3", "5", "6", "8", "0", "A"],
        numbers: ["1", "2", "3", "4", "5", "6", "b7"],
        underlinedNumbers: ["3", "b7"],
        chromaticFormula: true,
      },
    },
    6: {
      ArrowUp: null,
      ArrowDown: {
        x: 4,
        y: 3,
        prevDegree: "b5.",
        name: "mixo",
        nameColor: "#FF7F00",
        degree: "b6",
        degreeColor: "#00FF00",
        formulae: [1, 3, 5, 6, 8, 9, 11],
        formulaeOriginal: ["1", "3", "5", "6", "8", "9", "A"],
        numbers: ["1", "2", "3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["b7", "3"],
        doubleUnderlineNumbers: ["2", "b6"],
      },
    },
    7: {
      ArrowUp: {
        x: 0,
        y: 0,
        prevDegree: "1.",
        name: "ionian",
        nameColor: "#FF0000",
        formulae: [1, 3, 5, 6, 8, 10, 12],
        formulaeOriginal: ["1", "3", "5", "6", "8", "0", "B"],
        numbers: ["1", "2", "3", "4", "5", "6", "7"],
        underlinedNumbers: ["4", "7"],
      },
      ArrowDown: null,
    },
  },
  aeolian: {
    1: {
      ArrowUp: {
        x: 5,
        y: 0,
        prevDegree: "6.",
        name: "aeolian",
        nameColor: "#00FF00",
        formulae: [1, 3, 4, 6, 8, 9, 11],
        formulaeOriginal: ["1", "3", "4", "6", "8", "9", "A"],
        numbers: ["1", "2", "b3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["2", "b6"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 5,
        y: 1,
        prevDegree: "b6.",
        name: "lydian",
        nameColor: "#FFFFFF",
        degree: "♯2",
        degreeColor: "#FFFF00",
        secondDegree: "♯5",
        secondDegreeColor: "#fff",
        formulae: [1, 4, 5, 7, 9, 10, 12],
        formulaeOriginal: ["1", "4", "5", "7", "9", "0", "B"],
        numbers: ["1", "♯2", "3", "♯4", "♯5", "6", "7"],
        doubleUnderlineNumbers: ["1", "♯4"],
        underlinedNumbers: ["♯2", "6"],
      },
    },
    2: {
      ArrowUp: null,
      ArrowDown: {
        x: 2,
        y: 0,
        prevDegree: "3.",
        name: "phrygian",
        nameColor: "#1e62ff",
        formulae: [1, 2, 4, 6, 8, 9, 11],
        formulaeOriginal: ["1", "2", "4", "6", "8", "9", "A"],
        numbers: ["1", "b2", "b3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["b2", "5"],
      },
    },
    3: {
      ArrowUp: {
        x: 4,
        y: 3,
        prevDegree: "b5.",
        name: "mixo",
        nameColor: "#FF7F00",
        degree: "b6",
        degreeColor: "#00FF00",
        formulae: [1, 3, 5, 6, 8, 9, 11],
        formulaeOriginal: ["1", "3", "5", "6", "8", "9", "A"],
        numbers: ["1", "2", "3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["b7", "3"],
        doubleUnderlineNumbers: ["2", "b6"],
      },
      ArrowDown: null,
    },
    4: {
      ArrowUp: {
        x: 5,
        y: 0,
        prevDegree: "6.",
        name: "aeolian",
        nameColor: "#00FF00",
        formulae: [1, 3, 4, 6, 8, 9, 11],
        formulaeOriginal: ["1", "3", "4", "6", "8", "9", "A"],
        numbers: ["1", "2", "b3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["2", "b6"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 5,
        y: 0,
        prevDegree: "6.",
        name: "aeolian",
        nameColor: "#00FF00",
        formulae: [1, 3, 4, 6, 8, 9, 11],
        formulaeOriginal: ["1", "3", "4", "6", "8", "9", "A"],
        numbers: ["1", "2", "b3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["2", "b6"],
        chromaticFormula: true,
      },
    },
    5: {
      ArrowUp: null,
      ArrowDown: {
        x: 5,
        y: 3,
        prevDegree: "6.",
        name: "aeolian",
        nameColor: "#AE96FF",
        degree: "b5",
        degreeColor: "#00FF00",
        formulae: [1, 3, 4, 6, 7, 9, 11],
        formulaeOriginal: ["1", "3", "4", "6", "7", "9", "A"],
        numbers: ["1", "2", "b3", "4", "b5", "b6", "b7"],
        doubleUnderlineNumbers: ["1", "b5"],
        underlinedNumbers: ["2", "b6"],
      },
    },
    6: {
      ArrowUp: {
        x: 1,
        y: 0,
        prevDegree: "2.",
        name: "dorian",
        nameColor: "#FFFF00",
        formulae: [1, 3, 4, 6, 8, 10, 11],
        formulaeOriginal: ["1", "3", "4", "6", "8", "0", "A"],
        numbers: ["1", "2", "b3", "4", "5", "6", "b7"],
        underlinedNumbers: ["b3", "6"],
        // doubleUnderlineNumbers: ["5", "b7"],
      },
      ArrowDown: null,
    },
    7: {
      ArrowUp: {
        x: 0,
        y: 2,
        prevDegree: "1.",
        name: "aeolian",
        nameColor: "#00FF00",
        degree: "♮7",
        degreeColor: "#FF0000",
        formulae: [1, 3, 4, 6, 8, 9, 12],
        formulaeOriginal: ["1", "3", "4", "6", "8", "9", "B"],
        numbers: ["1", "2", "b3", "4", "5", "b6", "7"],
        underlinedNumbers: ["4", "7"],
        doubleUnderlineNumbers: ["2", "b6"],
      },
      ArrowDown: {
        x: 5,
        y: 0,
        prevDegree: "6.",
        name: "aeolian",
        nameColor: "#00FF00",
        formulae: [1, 3, 4, 6, 8, 9, 11],
        formulaeOriginal: ["1", "3", "4", "6", "8", "9", "A"],
        numbers: ["1", "2", "b3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["2", "b6"],
        chromaticFormula: true,
      },
    },
  },
  locrian: {
    1: {
      ArrowUp: null,
      ArrowDown: {
        x: 3,
        y: 0,
        prevDegree: "4.",
        name: "lydian",
        nameColor: "#ff00b7",
        formulae: [1, 3, 5, 7, 8, 10, 12],
        formulaeOriginal: ["1", "3", "5", "7", "8", "0", "B"],
        numbers: ["1", "2", "3", "♯4", "5", "6", "7"],
        underlinedNumbers: ["1", "♯4"],
      },
    },
    2: {
      ArrowUp: {
        x: 5,
        y: 3,
        prevDegree: "6.",
        name: "aeolian",
        nameColor: "#AE96FF",
        degree: "b5",
        degreeColor: "#00FF00",
        formulae: [1, 3, 4, 6, 7, 9, 11],
        formulaeOriginal: ["1", "3", "4", "6", "7", "9", "A"],
        numbers: ["1", "2", "b3", "4", "b5", "b6", "b7"],
        doubleUnderlineNumbers: ["1", "b5"],
        underlinedNumbers: ["2", "b6"],
      },
      ArrowDown: null,
    },
    3: {
      ArrowUp: {
        x: 6,
        y: 0,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#AE96FF",
        formulae: [1, 2, 4, 6, 7, 9, 11],
        formulaeOriginal: ["1", "2", "4", "6", "7", "9", "A"],
        numbers: ["1", "b2", "b3", "4", "b5", "b6", "b7"],
        underlinedNumbers: ["1", "b5"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 6,
        y: 0,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#AE96FF",
        formulae: [1, 2, 4, 6, 7, 9, 11],
        formulaeOriginal: ["1", "2", "4", "6", "7", "9", "A"],
        numbers: ["1", "b2", "b3", "4", "b5", "b6", "b7"],
        underlinedNumbers: ["1", "b5"],
        chromaticFormula: true,
      },
    },
    4: {
      ArrowUp: null,
      ArrowDown: {
        x: 6,
        y: 3,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#fff",
        degree: "b4",
        degreeColor: "#FF7F00",
        text: "(Altered Dominant)",
        formulae: [1, 2, 4, 5, 7, 9, 11],
        formulaeOriginal: ["1", "2", "4", "5", "7", "9", "A"],
        numbers: ["1", "b2", "b3", "b4", "b5", "b6", "b7"],
        underlinedNumbers: ["1", "b5"],
        doubleUnderlineNumbers: ["b4", "b7"],
      },
    },
    5: {
      ArrowUp: {
        x: 2,
        y: 0,
        prevDegree: "3.",
        name: "phrygian",
        nameColor: "#1e62ff",
        formulae: [1, 2, 4, 6, 8, 9, 11],
        formulaeOriginal: ["1", "2", "4", "6", "8", "9", "A"],
        numbers: ["1", "b2", "b3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["b2", "5"],
      },
      ArrowDown: null,
    },
    6: {
      ArrowUp: {
        x: 1,
        y: 2,
        prevDegree: "2.",
        name: "locrian",
        nameColor: "#AE96FF",
        degree: "♮6",
        degreeColor: "#FFFF00",
        formulae: [1, 2, 4, 6, 7, 10, 11],
        formulaeOriginal: ["1", "2", "4", "6", "7", "0", "A"],
        numbers: ["1", "b2", "b3", "4", "b5", "6", "b7"],
        doubleUnderlineNumbers: ["1", "b5"],
        underlinedNumbers: ["b3", "6"],
      },
      ArrowDown: {
        x: 6,
        y: 0,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#AE96FF",
        formulae: [1, 2, 4, 6, 7, 9, 11],
        formulaeOriginal: ["1", "2", "4", "6", "7", "9", "A"],
        numbers: ["1", "b2", "b3", "4", "b5", "b6", "b7"],
        underlinedNumbers: ["1", "b5"],
        chromaticFormula: true,
      },
    },
    7: {
      ArrowUp: {
        x: 6,
        y: 0,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#AE96FF",
        formulae: [1, 2, 4, 6, 7, 9, 11],
        formulaeOriginal: ["1", "2", "4", "6", "7", "9", "A"],
        numbers: ["1", "b2", "b3", "4", "b5", "b6", "b7"],
        underlinedNumbers: ["1", "b5"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 6,
        y: 1,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#AE96FF",
        degree: "bb7",
        degreeColor: "#FFFF00",
        formulae: [1, 2, 4, 6, 7, 9, 10],
        formulaeOriginal: ["1", "2", "4", "6", "7", "9", "0"],
        numbers: ["1", "b2", "b3", "4", "b5", "b6", "bb7"],
        doubleUnderlineNumbers: ["b3", "bb7"],
        underlinedNumbers: ["1", "b5"],
      },
    },
  },
  "ionian b3": {
    1: {
      ArrowUp: {
        x: 0,
        y: 2,
        name: "Whole",
        nameColor: "#00FF00",
        name2: "Tones",
        name2Color: "#FF7F00",
        formulae: [1, 3, 5, 7, 9, 11],
        formulaeOriginal: ["1", "3", "5", "7", "9", "A"],
        numbers: ["1", "2", "3", "♯4", "♯5", "♯6"],
        underlinedNumbers: ["2", "3", "♯5", "♯6"],
      },
      ArrowDown: null,
    },
    2: {
      ArrowUp: null,
      ArrowDown: {
        x: 0,
        y: 2,
        name: "Whole",
        nameColor: "#00FF00",
        name2: "Tones",
        name2Color: "#FF7F00",
        formulae: [1, 3, 5, 7, 9, 11],
        formulaeOriginal: ["1", "3", "5", "7", "9", "A"],
        numbers: ["1", "2", "3", "♯4", "♯5", "♯6"],
        underlinedNumbers: ["2", "3", "♯5", "♯6"],
      },
    },
    3: {
      ArrowUp: {
        x: 0,
        y: 0,
        prevDegree: "1.",
        name: "ionian",
        nameColor: "#FF0000",
        formulae: [1, 3, 5, 6, 8, 10, 12],
        formulaeOriginal: ["1", "3", "5", "6", "8", "0", "B"],
        numbers: ["1", "2", "3", "4", "5", "6", "7"],
        underlinedNumbers: ["4", "7"],
      },
      ArrowDown: null,
    },
    4: {
      ArrowUp: {
        x: 3,
        y: 1,
        prevDegree: "4.",
        name: "lydian",
        nameColor: "#ff00b7",
        degree: "b3",
        degreeColor: "#FFFF00",
        formulae: [1, 3, 4, 7, 8, 10, 12],
        formulaeOriginal: ["1", "3", "4", "7", "8", "0", "B"],
        numbers: ["1", "2", "b3", "♯4", "5", "6", "7"],
        underlinedNumbers: ["1", "♯4"],
        doubleUnderlineNumbers: ["b3", "6"],
      },
      ArrowDown: {
        x: 0,
        y: 3,
        prevDegree: "1.",
        name: "ionian",
        nameColor: "#FF0000",
        degree: "b3",
        degreeColor: "#FFFF00",
        formulae: [1, 3, 4, 6, 8, 10, 12],
        formulaeOriginal: ["1", "3", "4", "6", "8", "0", "B"],
        numbers: ["1", "2", "b3", "4", "5", "6", "7"],
        doubleUnderlineNumbers: ["b3", "6"],
        underlinedNumbers: ["4", "7"],
        chromaticFormula: true,
      },
    },
    5: {
      ArrowUp: {
        x: 1,
        y: 0,
        name: "Whole/half",
        formulae: [1, 3, 4, 6, 7, 9, 10, 12],
        formulaeOriginal: ["1", "3", "4", "6", "7", "9", "0", "B"],
        numbers: ["1", "2", "b3", "4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["2", "b3", "b5", "b6", "bb7", "b8"],
        squareNumbers: ["2", "4", "b6", "b8"],
      },
      ArrowDown: {
        x: 1,
        y: 0,
        name: "Whole/half",
        formulae: [1, 3, 4, 6, 7, 9, 10, 12],
        formulaeOriginal: ["1", "3", "4", "6", "7", "9", "0", "B"],
        numbers: ["1", "2", "b3", "4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["2", "b3", "b5", "b6", "bb7", "b8"],
        squareNumbers: ["2", "4", "b6", "b8"],
      },
    },
    6: {
      ArrowUp: {
        x: 0,
        y: 3,
        prevDegree: "1.",
        name: "ionian",
        nameColor: "#FF0000",
        degree: "b3",
        degreeColor: "#FFFF00",
        formulae: [1, 3, 4, 6, 8, 10, 12],
        formulaeOriginal: ["1", "3", "4", "6", "8", "0", "B"],
        numbers: ["1", "2", "b3", "4", "5", "6", "7"],
        doubleUnderlineNumbers: ["b3", "6"],
        underlinedNumbers: ["4", "7"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 0,
        y: 2,
        prevDegree: "1.",
        name: "aeolian",
        nameColor: "#00FF00",
        degree: "♮7",
        degreeColor: "#FF0000",
        formulae: [1, 3, 4, 6, 8, 9, 12],
        formulaeOriginal: ["1", "3", "4", "6", "8", "9", "B"],
        numbers: ["1", "2", "b3", "4", "5", "b6", "7"],
        underlinedNumbers: ["4", "7"],
        doubleUnderlineNumbers: ["2", "b6"],
      },
    },
    7: {
      ArrowUp: null,
      ArrowDown: {
        x: 1,
        y: 0,
        prevDegree: "2.",
        name: "dorian",
        nameColor: "#FFFF00",
        formulae: [1, 3, 4, 6, 8, 10, 11],
        formulaeOriginal: ["1", "3", "4", "6", "8", "0", "A"],
        numbers: ["1", "2", "b3", "4", "5", "6", "b7"],
        underlinedNumbers: ["b3", "6"],
      },
    },
  },
  "dorian b2": {
    1: {
      ArrowUp: null,
      ArrowDown: {
        x: 0,
        y: 2,
        name: "Whole",
        nameColor: "#00FF00",
        name2: "Tones",
        name2Color: "#FF7F00",
        formulae: [1, 3, 5, 7, 9, 11],
        formulaeOriginal: ["1", "3", "5", "7", "9", "A"],
        numbers: ["1", "2", "3", "♯4", "♯5", "♯6"],
        underlinedNumbers: ["2", "3", "♯5", "♯6"],
      },
    },
    2: {
      ArrowUp: {
        x: 1,
        y: 0,
        prevDegree: "2.",
        name: "dorian",
        nameColor: "#FFFF00",
        formulae: [1, 3, 4, 6, 8, 10, 11],
        formulaeOriginal: ["1", "3", "4", "6", "8", "0", "A"],
        numbers: ["1", "2", "b3", "4", "5", "6", "b7"],
        underlinedNumbers: ["b3", "6"],
      },
      ArrowDown: null,
    },
    3: {
      ArrowUp: {
        x: 4,
        y: 1,
        prevDegree: "5.",
        name: "mixo",
        nameColor: "#FF7F00",
        degree: "b2",
        degreeColor: "#1e62ff",
        formulae: [1, 2, 5, 6, 8, 10, 11],
        formulaeOriginal: ["1", "2", "5", "6", "8", "0", "A"],
        numbers: ["1", "b2", "3", "4", "5", "6", "b7"],
        doubleUnderlineNumbers: ["b2", "5"],
        underlinedNumbers: ["3", "b7"],
      },
      ArrowDown: {
        x: 1,
        y: 3,
        prevDegree: "2.",
        name: "dorian",
        nameColor: "#FFFF00",
        degree: "b2",
        degreeColor: "#1e62ff",
        formulae: [1, 2, 4, 6, 8, 10, 11],
        formulaeOriginal: ["1", "3", "4", "6", "8", "0", "B"],
        numbers: ["1", "2", "b3", "4", "b5", "6", "b7"],
        doubleUnderlineNumbers: ["2", "b5"],
        underlinedNumbers: ["b3", "6"],
        chromaticFormula: true,
      },
    },
    4: {
      ArrowUp: {
        x: 0,
        y: 0,
        name: "Half/whole",
        formulae: [1, 2, 4, 5, 7, 8, 10, 11],
        formulaeOriginal: ["1", "2", "4", "5", "7", "8", "0", "A"],
        numbers: ["1", "b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        squareNumbers: ["b2", "b4", "bb6", "bb8"],
      },
      ArrowDown: {
        x: 0,
        y: 0,
        name: "Half/whole",
        formulae: [1, 2, 4, 5, 7, 8, 10, 11],
        formulaeOriginal: ["1", "2", "4", "5", "7", "8", "0", "A"],
        numbers: ["1", "b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        squareNumbers: ["b2", "b4", "bb6", "bb8"],
      },
    },
    5: {
      ArrowUp: {
        x: 1,
        y: 3,
        prevDegree: "2.",
        name: "dorian",
        nameColor: "#FFFF00",
        degree: "b2",
        degreeColor: "#1e62ff",
        formulae: [1, 2, 4, 6, 8, 10, 11],
        formulaeOriginal: ["1", "3", "4", "6", "8", "0", "B"],
        numbers: ["1", "2", "b3", "4", "b5", "6", "b7"],
        doubleUnderlineNumbers: ["2", "b5"],
        underlinedNumbers: ["b3", "6"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 1,
        y: 2,
        prevDegree: "2.",
        name: "locrian",
        nameColor: "#AE96FF",
        degree: "♮6",
        degreeColor: "#FFFF00",
        formulae: [1, 2, 4, 6, 7, 10, 11],
        formulaeOriginal: ["1", "2", "4", "6", "7", "0", "A"],
        numbers: ["1", "b2", "b3", "4", "b5", "6", "b7"],
        doubleUnderlineNumbers: ["1", "b5"],
        underlinedNumbers: ["b3", "6"],
      },
    },
    6: {
      ArrowUp: null,
      ArrowDown: {
        x: 2,
        y: 0,
        prevDegree: "3.",
        name: "phrygian",
        nameColor: "#1e62ff",
        formulae: [1, 2, 4, 6, 8, 9, 11],
        formulaeOriginal: ["1", "2", "4", "6", "8", "9", "A"],
        numbers: ["1", "b2", "b3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["b2", "5"],
      },
    },
    7: {
      ArrowUp: {
        x: 0,
        y: 2,
        name: "Whole",
        nameColor: "#00FF00",
        name2: "Tones",
        name2Color: "#FF7F00",
        formulae: [1, 3, 5, 7, 9, 11],
        formulaeOriginal: ["1", "3", "5", "7", "9", "A"],
        numbers: ["1", "2", "3", "♯4", "♯5", "♯6"],
        underlinedNumbers: ["2", "3", "♯5", "♯6"],
      },
      ArrowDown: null,
    },
  },
  "lydian ♯5": {
    1: {
      ArrowUp: {
        x: 2,
        y: 0,
        prevDegree: "3.",
        name: "phrygian",
        nameColor: "#1e62ff",
        formulae: [1, 2, 4, 6, 8, 9, 11],
        formulaeOriginal: ["1", "2", "4", "6", "8", "9", "A"],
        numbers: ["1", "b2", "b3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["b2", "5"],
      },
      ArrowDown: null,
    },
    2: {
      ArrowUp: {
        x: 5,
        y: 1,
        prevDegree: "b6.",
        name: "lydian",
        nameColor: "#FFFFFF",
        degree: "♯2",
        degreeColor: "#FFFF00",
        secondDegree: "♯5",
        secondDegreeColor: "#fff",
        formulae: [1, 4, 5, 7, 9, 10, 12],
        formulaeOriginal: ["1", "4", "5", "7", "9", "0", "B"],
        numbers: ["1", "♯2", "3", "♯4", "♯5", "6", "7"],
        doubleUnderlineNumbers: ["1", "♯4"],
        underlinedNumbers: ["♯2", "6"],
      },
      ArrowDown: {
        x: 2,
        y: 3,
        prevDegree: "b3.",
        name: "lydian",
        nameColor: "#fff",
        degree: "♯5",
        degreeColor: "#00FF00",
        // secondDegree: "♯5",
        // secondDegreeColor: "#fff",
        formulae: [1, 3, 5, 7, 9, 10, 12],
        formulaeOriginal: ["1", "3", "5", "7", "9", "0", "B"],
        numbers: ["1", "2", "3", "♯4", "♯5", "6", "7"],
        doubleUnderlineNumbers: ["1", "♯4"],
        underlinedNumbers: ["2", "♯5"],
        chromaticFormula: true,
      },
    },
    3: {
      ArrowUp: {
        x: 1,
        y: 0,
        name: "Whole/half",
        formulae: [1, 3, 4, 6, 7, 9, 10, 12],
        formulaeOriginal: ["1", "3", "4", "6", "7", "9", "0", "B"],
        numbers: ["1", "2", "b3", "4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["2", "b3", "b5", "b6", "bb7", "b8"],
        squareNumbers: ["2", "4", "b6", "b8"],
      },
      ArrowDown: {
        x: 1,
        y: 0,
        name: "Whole/half",
        formulae: [1, 3, 4, 6, 7, 9, 10, 12],
        formulaeOriginal: ["1", "3", "4", "6", "7", "9", "0", "B"],
        numbers: ["1", "2", "b3", "4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["2", "b3", "b5", "b6", "bb7", "b8"],
        squareNumbers: ["2", "4", "b6", "b8"],
      },
    },
    4: {
      ArrowUp: {
        x: 2,
        y: 3,
        prevDegree: "b3.",
        name: "lydian",
        nameColor: "#fff",
        degree: "♯5",
        degreeColor: "#00FF00",
        // secondDegree: "♯5",
        // secondDegreeColor: "#fff",
        formulae: [1, 3, 5, 7, 9, 10, 12],
        formulaeOriginal: ["1", "3", "5", "7", "9", "0", "B"],
        numbers: ["1", "2", "3", "♯4", "♯5", "6", "7"],
        doubleUnderlineNumbers: ["1", "♯4"],
        underlinedNumbers: ["2", "♯5"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 2,
        y: 2,
        prevDegree: "b3.",
        name: "ionian",
        nameColor: "#FF0000",
        degree: "♯5",
        degreeColor: "#00FF00",
        formulae: [1, 3, 5, 6, 9, 10, 12],
        formulaeOriginal: ["1", "3", "5", "6", "9", "0", "B"],
        numbers: ["1", "2", "3", "4", "♯5", "6", "7"],
        doubleUnderlineNumbers: ["4", "7"],
        underlinedNumbers: ["2", "♯5"],
      },
    },
    5: {
      ArrowUp: null,
      ArrowDown: {
        x: 3,
        y: 0,
        prevDegree: "4.",
        name: "lydian",
        nameColor: "#ff00b7",
        formulae: [1, 3, 5, 7, 8, 10, 12],
        formulaeOriginal: ["1", "3", "5", "7", "8", "0", "B"],
        numbers: ["1", "2", "3", "♯4", "5", "6", "7"],
        underlinedNumbers: ["1", "♯4"],
      },
    },
    6: {
      ArrowUp: {
        x: 0,
        y: 2,
        name: "Whole",
        nameColor: "#00FF00",
        name2: "Tones",
        name2Color: "#FF7F00",
        formulae: [1, 3, 5, 7, 9, 11],
        formulaeOriginal: ["1", "3", "5", "7", "9", "A"],
        numbers: ["1", "2", "3", "♯4", "♯5", "♯6"],
        underlinedNumbers: ["2", "3", "♯5", "♯6"],
      },
      ArrowDown: null,
    },
    7: {
      ArrowUp: null,
      ArrowDown: {
        x: 0,
        y: 2,
        name: "Whole",
        nameColor: "#00FF00",
        name2: "Tones",
        name2Color: "#FF7F00",
        formulae: [1, 3, 5, 7, 9, 11],
        formulaeOriginal: ["1", "3", "5", "7", "9", "A"],
        numbers: ["1", "2", "3", "♯4", "♯5", "♯6"],
        underlinedNumbers: ["2", "3", "♯5", "♯6"],
      },
    },
  },
  "lydian b7": {
    1: {
      ArrowUp: {
        x: 6,
        y: 1,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#AE96FF",
        degree: "bb7",
        degreeColor: "#FFFF00",
        formulae: [1, 2, 4, 6, 7, 9, 10],
        formulaeOriginal: ["1", "2", "4", "6", "7", "9", "0"],
        numbers: ["1", "b2", "b3", "4", "b5", "b6", "bb7"],
        doubleUnderlineNumbers: ["b3", "bb7"],
        underlinedNumbers: ["1", "b5"],
      },
      ArrowDown: {
        x: 3,
        y: 3,
        prevDegree: "4.",
        name: "lydian",
        nameColor: "#ff00b7",
        degree: "b7",
        degreeColor: "#FF7F00",
        formulae: [1, 3, 5, 7, 8, 10, 11],
        formulaeOriginal: ["1", "3", "5", "7", "8", "0", "A"],
        numbers: ["1", "2", "3", "♯4", "5", "6", "b7"],
        underlinedNumbers: ["1", "♯4"],
        doubleUnderlineNumbers: ["3", "b7"],
        chromaticFormula: true,
      },
    },
    2: {
      ArrowUp: {
        x: 0,
        y: 0,
        name: "Half/whole",
        formulae: [1, 2, 4, 5, 7, 8, 10, 11],
        formulaeOriginal: ["1", "2", "4", "5", "7", "8", "0", "A"],
        numbers: ["1", "b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        squareNumbers: ["b2", "b4", "bb6", "bb8"],
      },
      ArrowDown: {
        x: 0,
        y: 0,
        name: "Half/whole",
        formulae: [1, 2, 4, 5, 7, 8, 10, 11],
        formulaeOriginal: ["1", "2", "4", "5", "7", "8", "0", "A"],
        numbers: ["1", "b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        squareNumbers: ["b2", "b4", "bb6", "bb8"],
      },
    },
    3: {
      ArrowUp: {
        x: 3,
        y: 3,
        prevDegree: "4.",
        name: "lydian",
        nameColor: "#ff00b7",
        degree: "b7",
        degreeColor: "#FF7F00",
        formulae: [1, 3, 5, 7, 8, 10, 11],
        formulaeOriginal: ["1", "3", "5", "7", "8", "0", "A"],
        numbers: ["1", "2", "3", "♯4", "5", "6", "b7"],
        underlinedNumbers: ["1", "♯4"],
        doubleUnderlineNumbers: ["3", "b7"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 3,
        y: 2,
        prevDegree: "4.",
        name: "dorian",
        nameColor: "#FFFF00",
        degree: "♯4",
        degreeColor: "#ff00b7",
        formulae: [1, 3, 4, 7, 8, 10, 11],
        formulaeOriginal: ["1", "3", "4", "7", "8", "0", "A"],
        numbers: ["1", "2", "b3", "♯4", "5", "6", "b7"],
        underlinedNumbers: ["1", "♯4"],
        doubleUnderlineNumbers: ["b3", "6"],
      },
    },
    4: {
      ArrowUp: null,
      ArrowDown: {
        x: 4,
        y: 0,
        prevDegree: "5.",
        name: "mixo",
        nameColor: "#FF7F00",
        formulae: [1, 3, 5, 6, 8, 10, 11],
        formulaeOriginal: ["1", "3", "5", "6", "8", "0", "A"],
        numbers: ["1", "2", "3", "4", "5", "6", "b7"],
        underlinedNumbers: ["3", "b7"],
      },
    },
    5: {
      ArrowUp: {
        x: 0,
        y: 2,
        name: "Whole",
        nameColor: "#00FF00",
        name2: "Tones",
        name2Color: "#FF7F00",
        formulae: [1, 3, 5, 7, 9, 11],
        formulaeOriginal: ["1", "3", "5", "7", "9", "A"],
        numbers: ["1", "2", "3", "♯4", "♯5", "♯6"],
        underlinedNumbers: ["2", "3", "♯5", "♯6"],
      },
      ArrowDown: null,
    },
    6: {
      ArrowUp: null,
      ArrowDown: {
        x: 0,
        y: 2,
        name: "Whole",
        nameColor: "#00FF00",
        name2: "Tones",
        name2Color: "#FF7F00",
        formulae: [1, 3, 5, 7, 9, 11],
        formulaeOriginal: ["1", "3", "5", "7", "9", "A"],
        numbers: ["1", "2", "3", "♯4", "♯5", "♯6"],
        underlinedNumbers: ["2", "3", "♯5", "♯6"],
      },
    },
    7: {
      ArrowUp: {
        x: 3,
        y: 0,
        prevDegree: "4.",
        name: "lydian",
        nameColor: "#ff00b7",
        formulae: [1, 3, 5, 7, 8, 10, 12],
        formulaeOriginal: ["1", "3", "5", "7", "8", "0", "B"],
        numbers: ["1", "2", "3", "♯4", "5", "6", "7"],
        underlinedNumbers: ["1", "♯4"],
      },
      ArrowDown: null,
    },
  },
  "mixo b6": {
    1: {
      ArrowUp: {
        x: 0,
        y: 0,
        name: "Half/whole",
        formulae: [1, 2, 4, 5, 7, 8, 10, 11],
        formulaeOriginal: ["1", "2", "4", "5", "7", "8", "0", "A"],
        numbers: ["1", "b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        squareNumbers: ["b2", "b4", "bb6", "bb8"],
      },
      ArrowDown: {
        x: 1,
        y: 0,
        name: "Whole/half",
        formulae: [1, 3, 4, 6, 7, 9, 10, 12],
        formulaeOriginal: ["1", "3", "4", "6", "7", "9", "0", "B"],
        numbers: ["1", "2", "b3", "4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["2", "b3", "b5", "b6", "bb7", "b8"],
        squareNumbers: ["2", "4", "b6", "b8"],
      },
    },
    2: {
      ArrowUp: {
        x: 4,
        y: 3,
        prevDegree: "b5.",
        name: "mixo",
        nameColor: "#FF7F00",
        degree: "b6",
        degreeColor: "#00FF00",
        formulae: [1, 3, 5, 6, 8, 9, 11],
        formulaeOriginal: ["1", "3", "5", "6", "8", "9", "A"],
        numbers: ["1", "2", "3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["b7", "3"],
        doubleUnderlineNumbers: ["2", "b6"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 4,
        y: 2,
        prevDegree: "5.",
        name: "phrygian",
        nameColor: "#1e62ff",
        degree: "♮3",
        degreeColor: "#ff7f00",
        formulae: [1, 2, 5, 6, 8, 9, 11],
        formulaeOriginal: ["1", "2", "5", "6", "8", "9", "A"],
        numbers: ["1", "b2", "3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["3", "b7"],
        doubleUnderlineNumbers: ["b2", "5"],
      },
    },
    3: {
      ArrowUp: null,
      ArrowDown: {
        x: 5,
        y: 0,
        prevDegree: "6.",
        name: "aeolian",
        nameColor: "#00FF00",
        formulae: [1, 3, 4, 6, 8, 9, 11],
        formulaeOriginal: ["1", "3", "4", "6", "8", "9", "A"],
        numbers: ["1", "2", "b3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["2", "b6"],
      },
    },
    4: {
      ArrowUp: {
        x: 0,
        y: 2,
        name: "Whole",
        nameColor: "#00FF00",
        name2: "Tones",
        name2Color: "#FF7F00",
        formulae: [1, 3, 5, 7, 9, 11],
        formulaeOriginal: ["1", "3", "5", "7", "9", "A"],
        numbers: ["1", "2", "3", "♯4", "♯5", "♯6"],
        underlinedNumbers: ["2", "3", "♯5", "♯6"],
      },
      ArrowDown: null,
    },
    5: {
      ArrowUp: null,
      ArrowDown: {
        x: 0,
        y: 2,
        name: "Whole",
        nameColor: "#00FF00",
        name2: "Tones",
        name2Color: "#FF7F00",
        formulae: [1, 3, 5, 7, 9, 11],
        formulaeOriginal: ["1", "3", "5", "7", "9", "A"],
        numbers: ["1", "2", "3", "♯4", "♯5", "♯6"],
        underlinedNumbers: ["2", "3", "♯5", "♯6"],
      },
    },
    6: {
      ArrowUp: {
        x: 4,
        y: 0,
        prevDegree: "5.",
        name: "mixo",
        nameColor: "#FF7F00",
        formulae: [1, 3, 5, 6, 8, 10, 11],
        formulaeOriginal: ["1", "3", "5", "6", "8", "0", "A"],
        numbers: ["1", "2", "3", "4", "5", "6", "b7"],
        underlinedNumbers: ["3", "b7"],
      },
      ArrowDown: null,
    },
    7: {
      ArrowUp: {
        x: 0,
        y: 1,
        prevDegree: "1.",
        name: "ionian",
        nameColor: "#FF0000",
        degree: "b6",
        degreeColor: "#00FF00",
        formulae: [1, 3, 5, 6, 8, 9, 12],
        formulaeOriginal: ["1", "3", "5", "6", "8", "9", "B"],
        numbers: ["1", "2", "3", "4", "5", "b6", "7"],
        doubleUnderlineNumbers: ["2", "b6"],
        underlinedNumbers: ["4", "7"],
      },
      ArrowDown: {
        x: 4,
        y: 3,
        prevDegree: "b5.",
        name: "mixo",
        nameColor: "#FF7F00",
        degree: "b6",
        degreeColor: "#00FF00",
        formulae: [1, 3, 5, 6, 8, 9, 11],
        formulaeOriginal: ["1", "3", "5", "6", "8", "9", "A"],
        numbers: ["1", "2", "3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["b7", "3"],
        doubleUnderlineNumbers: ["2", "b6"],
        chromaticFormula: true,
      },
    },
  },
  "aeolian b5": {
    1: {
      ArrowUp: {
        x: 5,
        y: 3,
        prevDegree: "6.",
        name: "aeolian",
        nameColor: "#AE96FF",
        degree: "b5",
        degreeColor: "#00FF00",
        formulae: [1, 3, 4, 6, 7, 9, 11],
        formulaeOriginal: ["1", "3", "4", "6", "7", "9", "A"],
        numbers: ["1", "2", "b3", "4", "b5", "b6", "b7"],
        doubleUnderlineNumbers: ["1", "b5"],
        underlinedNumbers: ["2", "b6"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 5,
        y: 2,
        prevDegree: "b6.",
        name: "lydian",
        nameColor: "#ff00b7",
        degree: "♯2",
        degreeColor: "#FFFF00",
        formulae: [1, 4, 5, 7, 8, 10, 12],
        formulaeOriginal: ["1", "4", "5", "7", "8", "0", "B"],
        numbers: ["1", "♯2", "3", "♯4", "5", "6", "7"],
        doubleUnderlineNumbers: ["1", "♯4"],
        underlinedNumbers: ["♯2", "6"],
      },
    },
    2: {
      ArrowUp: null,
      ArrowDown: {
        x: 6,
        y: 0,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#AE96FF",
        formulae: [1, 2, 4, 6, 7, 9, 11],
        formulaeOriginal: ["1", "2", "4", "6", "7", "9", "A"],
        numbers: ["1", "b2", "b3", "4", "b5", "b6", "b7"],
        underlinedNumbers: ["1", "b5"],
      },
    },
    3: {
      ArrowUp: {
        x: 0,
        y: 2,
        name: "Whole",
        nameColor: "#00FF00",
        name2: "Tones",
        name2Color: "#FF7F00",
        formulae: [1, 3, 5, 7, 9, 11],
        formulaeOriginal: ["1", "3", "5", "7", "9", "A"],
        numbers: ["1", "2", "3", "♯4", "♯5", "♯6"],
        underlinedNumbers: ["2", "3", "♯5", "♯6"],
      },
      ArrowDown: null,
    },
    4: {
      ArrowUp: null,
      ArrowDown: {
        x: 0,
        y: 2,
        name: "Whole",
        nameColor: "#00FF00",
        name2: "Tones",
        name2Color: "#FF7F00",
        formulae: [1, 3, 5, 7, 9, 11],
        formulaeOriginal: ["1", "3", "5", "7", "9", "A"],
        numbers: ["1", "2", "3", "♯4", "♯5", "♯6"],
        underlinedNumbers: ["2", "3", "♯5", "♯6"],
      },
    },
    5: {
      ArrowUp: {
        x: 5,
        y: 0,
        prevDegree: "6.",
        name: "aeolian",
        nameColor: "#00FF00",
        formulae: [1, 3, 4, 6, 8, 9, 11],
        formulaeOriginal: ["1", "3", "4", "6", "8", "9", "A"],
        numbers: ["1", "2", "b3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["2", "b6"],
      },
      ArrowDown: null,
    },
    6: {
      ArrowUp: {
        x: 1,
        y: 1,
        prevDegree: "2.",
        name: "dorian",
        nameColor: "#FFFF00",
        degree: "b5",
        degreeColor: "#1e62ff",
        formulae: [1, 3, 4, 6, 7, 10, 11],
        formulaeOriginal: ["1", "3", "4", "6", "7", "0", "A"],
        numbers: ["1", "2", "b3", "4", "b5", "6", "b7"],
        doubleUnderlineNumbers: ["1", "b5"],
        underlinedNumbers: ["b3", "6"],
      },
      ArrowDown: {
        x: 5,
        y: 3,
        prevDegree: "6.",
        name: "aeolian",
        nameColor: "#AE96FF",
        degree: "b5",
        degreeColor: "#00FF00",
        formulae: [1, 3, 4, 6, 7, 9, 11],
        formulaeOriginal: ["1", "3", "4", "6", "7", "9", "A"],
        numbers: ["1", "2", "b3", "4", "b5", "b6", "b7"],
        doubleUnderlineNumbers: ["1", "b5"],
        underlinedNumbers: ["2", "b6"],
        chromaticFormula: true,
      },
    },
    7: {
      ArrowUp: {
        x: 1,
        y: 0,
        name: "Whole/half",
        formulae: [1, 3, 4, 6, 7, 9, 10, 12],
        formulaeOriginal: ["1", "3", "4", "6", "7", "9", "0", "B"],
        numbers: ["1", "2", "b3", "4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["2", "b3", "b5", "b6", "bb7", "b8"],
        squareNumbers: ["2", "4", "b6", "b8"],
      },
      ArrowDown: {
        x: 1,
        y: 0,
        name: "Whole/half",
        formulae: [1, 3, 4, 6, 7, 9, 10, 12],
        formulaeOriginal: ["1", "3", "4", "6", "7", "9", "0", "B"],
        numbers: ["1", "2", "b3", "4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["2", "b3", "b5", "b6", "bb7", "b8"],
        squareNumbers: ["2", "4", "b6", "b8"],
      },
    },
  },
  "locrian b4": {
    1: {
      ArrowUp: null,
      ArrowDown: {
        x: 0,
        y: 0,
        prevDegree: "1.",
        name: "ionian",
        nameColor: "#FF0000",
        formulae: [1, 3, 5, 6, 8, 10, 12],
        formulaeOriginal: ["1", "3", "5", "6", "8", "0", "B"],
        numbers: ["1", "2", "3", "4", "5", "6", "7"],
        underlinedNumbers: ["4", "7"],
      },
    },
    2: {
      ArrowUp: {
        x: 0,
        y: 2,
        name: "Whole",
        nameColor: "#00FF00",
        name2: "Tones",
        name2Color: "#FF7F00",
        formulae: [1, 3, 5, 7, 9, 11],
        formulaeOriginal: ["1", "3", "5", "7", "9", "A"],
        numbers: ["1", "2", "3", "♯4", "♯5", "♯6"],
        underlinedNumbers: ["2", "3", "♯5", "♯6"],
      },
      ArrowDown: null,
    },
    3: {
      ArrowUp: null,
      ArrowDown: {
        x: 0,
        y: 2,
        name: "Whole",
        nameColor: "#00FF00",
        name2: "Tones",
        name2Color: "#FF7F00",
        formulae: [1, 3, 5, 7, 9, 11],
        formulaeOriginal: ["1", "3", "5", "7", "9", "A"],
        numbers: ["1", "2", "3", "♯4", "♯5", "♯6"],
        underlinedNumbers: ["2", "3", "♯5", "♯6"],
      },
    },
    4: {
      ArrowUp: {
        x: 6,
        y: 0,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#AE96FF",
        formulae: [1, 2, 4, 6, 7, 9, 11],
        formulaeOriginal: ["1", "2", "4", "6", "7", "9", "A"],
        numbers: ["1", "b2", "b3", "4", "b5", "b6", "b7"],
        underlinedNumbers: ["1", "b5"],
      },
      ArrowDown: null,
    },
    5: {
      ArrowUp: {
        x: 2,
        y: 1,
        prevDegree: "3.",
        name: "phrygian",
        nameColor: "#1e62ff",
        degree: "b4",
        degreeColor: "#FF7F00",
        formulae: [1, 2, 4, 5, 8, 9, 11],
        formulaeOriginal: ["1", "2", "4", "5", "8", "9", "A"],
        numbers: ["1", "b2", "b3", "b4", "5", "b6", "b7"],
        underlinedNumbers: ["b2", "5"],
        doubleUnderlineNumbers: ["b4", "b7"],
      },
      ArrowDown: {
        x: 6,
        y: 3,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#fff",
        degree: "b4",
        degreeColor: "#FF7F00",
        text: "(Altered Dominant)",
        formulae: [1, 2, 4, 5, 7, 9, 11],
        formulaeOriginal: ["1", "2", "4", "5", "7", "9", "A"],
        numbers: ["1", "b2", "b3", "b4", "b5", "b6", "b7"],
        underlinedNumbers: ["1", "b5"],
        chromaticFormula: true,

        doubleUnderlineNumbers: ["b4", "b7"],
      },
    },
    6: {
      ArrowUp: {
        x: 0,
        y: 0,
        name: "Half/whole",
        formulae: [1, 2, 4, 5, 7, 8, 10, 11],
        formulaeOriginal: ["1", "2", "4", "5", "7", "8", "0", "A"],
        numbers: ["1", "b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        squareNumbers: ["b2", "b4", "bb6", "bb8"],
      },
      ArrowDown: {
        x: 0,
        y: 0,
        name: "Half/whole",
        formulae: [1, 2, 4, 5, 7, 8, 10, 11],
        formulaeOriginal: ["1", "2", "4", "5", "7", "8", "0", "A"],
        numbers: ["1", "b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        squareNumbers: ["b2", "b4", "bb6", "bb8"],
      },
    },
    7: {
      ArrowUp: {
        x: 6,
        y: 3,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#fff",
        degree: "b4",
        degreeColor: "#FF7F00",
        text: "(Altered Dominant)",
        formulae: [1, 2, 4, 5, 7, 9, 11],
        formulaeOriginal: ["1", "2", "4", "5", "7", "9", "A"],
        numbers: ["1", "b2", "b3", "b4", "b5", "b6", "b7"],
        underlinedNumbers: ["1", "b5"],
        doubleUnderlineNumbers: ["b4", "b7"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 6,
        y: 2,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#fff",
        degree: "b4",
        degreeColor: "#fff",
        secondDegree: "bb7",
        secondDegreeColor: "#FFFF00",
        text: "(Altered bb7)",
        formulae: [1, 2, 4, 5, 7, 9, 10],
        formulaeOriginal: ["1", "2", "4", "5", "7", "9", "0"],
        numbers: ["1", "b2", "b3", "b4", "b5", "b6", "bb7"],
        underlinedNumbers: ["1", "b5"],
        doubleUnderlineNumbers: ["b3", "bb7"],
      },
    },
  },
  "aeolian ♮7": {
    1: {
      ArrowUp: {
        x: 0,
        y: 2,
        prevDegree: "1.",
        name: "aeolian",
        nameColor: "#00FF00",
        degree: "♮7",
        degreeColor: "#FF0000",
        formulae: [1, 3, 4, 6, 8, 9, 12],
        formulaeOriginal: ["1", "3", "4", "6", "8", "9", "B"],
        numbers: ["1", "2", "b3", "4", "5", "b6", "7"],
        underlinedNumbers: ["4", "7"],
        doubleUnderlineNumbers: ["2", "b6"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 5,
        y: 1,
        prevDegree: "b6.",
        name: "lydian",
        nameColor: "#FFFFFF",
        degree: "♯2",
        degreeColor: "#FFFF00",
        secondDegree: "♯5",
        secondDegreeColor: "#fff",
        formulae: [1, 4, 5, 7, 9, 10, 12],
        formulaeOriginal: ["1", "4", "5", "7", "9", "0", "B"],
        numbers: ["1", "♯2", "3", "♯4", "♯5", "6", "7"],
        doubleUnderlineNumbers: ["1", "♯4"],
        underlinedNumbers: ["♯2", "6"],
      },
    },
    2: {
      ArrowUp: null,
      ArrowDown: {
        x: 0,
        y: 2,
        prevDegree: "1.",
        name: "aeolian",
        nameColor: "#00FF00",
        degree: "♮7",
        degreeColor: "#FF0000",
        formulae: [1, 3, 4, 6, 8, 9, 12],
        formulaeOriginal: ["1", "3", "4", "6", "8", "9", "B"],
        numbers: ["1", "2", "b3", "4", "5", "b6", "7"],
        underlinedNumbers: ["4", "7"],
        doubleUnderlineNumbers: ["2", "b6"],
        chromaticFormula: true,
      },
    },
    3: {
      ArrowUp: {
        x: 0,
        y: 1,
        prevDegree: "1.",
        name: "ionian",
        nameColor: "#FF0000",
        degree: "b6",
        degreeColor: "#00FF00",
        formulae: [1, 3, 5, 6, 8, 9, 12],
        formulaeOriginal: ["1", "3", "5", "6", "8", "9", "B"],
        numbers: ["1", "2", "3", "4", "5", "b6", "7"],
        doubleUnderlineNumbers: ["2", "b6"],
        underlinedNumbers: ["4", "7"],
      },
      ArrowDown: null,
    },
    4: {
      ArrowUp: {
        x: 0,
        y: 2,
        prevDegree: "1.",
        name: "aeolian",
        nameColor: "#00FF00",
        degree: "♮7",
        degreeColor: "#FF0000",
        formulae: [1, 3, 4, 6, 8, 9, 12],
        formulaeOriginal: ["1", "3", "4", "6", "8", "9", "B"],
        numbers: ["1", "2", "b3", "4", "5", "b6", "7"],
        underlinedNumbers: ["4", "7"],
        doubleUnderlineNumbers: ["2", "b6"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 0,
        y: 1,
        nameColor: "#fff",
        degreeColor: "#fff",
        name: "Hexa",
        degree: "♯2",
        formulae: [1, 4, 5, 8, 9, 12],
        formulaeOriginal: ["1", "4", "5", "8", "9", "B"],
        numbers: ["1", "♯2", "3", "X4", "♯5", "X6"],
        squareNumbers: ["♯2", "X4", "X6"],
      },
    },
    5: {
      ArrowUp: {
        x: 1,
        y: 0,
        name: "Whole/half",
        formulae: [1, 3, 4, 6, 7, 9, 10, 12],
        formulaeOriginal: ["1", "3", "4", "6", "7", "9", "0", "B"],
        numbers: ["1", "2", "b3", "4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["2", "b3", "b5", "b6", "bb7", "b8"],
        squareNumbers: ["2", "4", "b6", "b8"],
      },
      ArrowDown: {
        x: 1,
        y: 0,
        name: "Whole/half",
        formulae: [1, 3, 4, 6, 7, 9, 10, 12],
        formulaeOriginal: ["1", "3", "4", "6", "7", "9", "0", "B"],
        numbers: ["1", "2", "b3", "4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["2", "b3", "b5", "b6", "bb7", "b8"],
        squareNumbers: ["2", "4", "b6", "b8"],
      },
    },
    6: {
      ArrowUp: {
        x: 0,
        y: 3,
        prevDegree: "1.",
        name: "ionian",
        nameColor: "#FF0000",
        degree: "b3",
        degreeColor: "#FFFF00",
        formulae: [1, 3, 4, 6, 8, 10, 12],
        formulaeOriginal: ["1", "3", "4", "6", "8", "0", "B"],
        numbers: ["1", "2", "b3", "4", "5", "6", "7"],
        doubleUnderlineNumbers: ["b3", "6"],
        underlinedNumbers: ["4", "7"],
      },
      ArrowDown: null,
    },
    7: {
      ArrowUp: null,
      ArrowDown: {
        x: 5,
        y: 0,
        prevDegree: "6.",
        name: "aeolian",
        nameColor: "#00FF00",
        formulae: [1, 3, 4, 6, 8, 9, 11],
        formulaeOriginal: ["1", "3", "4", "6", "8", "9", "A"],
        numbers: ["1", "2", "b3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["2", "b6"],
      },
    },
  },
  "locrian ♮6": {
    1: {
      ArrowUp: null,
      ArrowDown: {
        x: 1,
        y: 2,
        prevDegree: "2.",
        name: "locrian",
        nameColor: "#AE96FF",
        degree: "♮6",
        degreeColor: "#FFFF00",
        formulae: [1, 2, 4, 6, 7, 10, 11],
        formulaeOriginal: ["1", "2", "4", "6", "7", "0", "A"],
        numbers: ["1", "b2", "b3", "4", "b5", "6", "b7"],
        doubleUnderlineNumbers: ["1", "b5"],
        underlinedNumbers: ["b3", "6"],
        chromaticFormula: true,
      },
    },
    2: {
      ArrowUp: {
        x: 1,
        y: 1,
        prevDegree: "2.",
        name: "dorian",
        nameColor: "#FFFF00",
        degree: "b5",
        degreeColor: "#1e62ff",
        formulae: [1, 3, 4, 6, 7, 10, 11],
        formulaeOriginal: ["1", "3", "4", "6", "7", "0", "A"],
        numbers: ["1", "2", "b3", "4", "b5", "6", "b7"],
        doubleUnderlineNumbers: ["1", "b5"],
        underlinedNumbers: ["b3", "6"],
      },
      ArrowDown: null,
    },
    3: {
      ArrowUp: {
        x: 1,
        y: 2,
        prevDegree: "2.",
        name: "locrian",
        nameColor: "#AE96FF",
        degree: "♮6",
        degreeColor: "#FFFF00",
        formulae: [1, 2, 4, 6, 7, 10, 11],
        formulaeOriginal: ["1", "2", "4", "6", "7", "0", "A"],
        numbers: ["1", "b2", "b3", "4", "b5", "6", "b7"],
        doubleUnderlineNumbers: ["1", "b5"],
        underlinedNumbers: ["b3", "6"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 0,
        y: 0,
        nameColor: "#fff",
        degreeColor: "#fff",
        name: "Hexa",
        degree: "b2",
        formulae: [1, 2, 5, 6, 9, 10],
        formulaeOriginal: ["1", "2", "5", "6", "9", "0"],
        numbers: ["1", "b2", "3", "4", "♯5", "6"],
        squareNumbers: ["b2", "4", "6"],
      },
    },
    4: {
      ArrowUp: {
        x: 0,
        y: 0,
        name: "Half/whole",
        formulae: [1, 2, 4, 5, 7, 8, 10, 11],
        formulaeOriginal: ["1", "2", "4", "5", "7", "8", "0", "A"],
        numbers: ["1", "b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        squareNumbers: ["b2", "b4", "bb6", "bb8"],
      },
      ArrowDown: {
        x: 0,
        y: 0,
        name: "Half/whole",
        formulae: [1, 2, 4, 5, 7, 8, 10, 11],
        formulaeOriginal: ["1", "2", "4", "5", "7", "8", "0", "A"],
        numbers: ["1", "b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        squareNumbers: ["b2", "b4", "bb6", "bb8"],
      },
    },
    5: {
      ArrowUp: {
        x: 1,
        y: 3,
        prevDegree: "2.",
        name: "dorian",
        nameColor: "#FFFF00",
        degree: "b2",
        degreeColor: "#1e62ff",
        formulae: [1, 2, 4, 6, 8, 10, 11],
        formulaeOriginal: ["1", "3", "4", "6", "8", "0", "B"],
        numbers: ["1", "2", "b3", "4", "b5", "6", "b7"],
        doubleUnderlineNumbers: ["2", "b5"],
        underlinedNumbers: ["b3", "6"],
      },
      ArrowDown: null,
    },
    6: {
      ArrowUp: null,
      ArrowDown: {
        x: 6,
        y: 0,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#AE96FF",
        formulae: [1, 2, 4, 6, 7, 9, 11],
        formulaeOriginal: ["1", "2", "4", "6", "7", "9", "A"],
        numbers: ["1", "b2", "b3", "4", "b5", "b6", "b7"],
        underlinedNumbers: ["1", "b5"],
      },
    },
    7: {
      ArrowUp: {
        x: 1,
        y: 2,
        prevDegree: "2.",
        name: "locrian",
        nameColor: "#AE96FF",
        degree: "♮6",
        degreeColor: "#FFFF00",
        formulae: [1, 2, 4, 6, 7, 10, 11],
        formulaeOriginal: ["1", "2", "4", "6", "7", "0", "A"],
        numbers: ["1", "b2", "b3", "4", "b5", "6", "b7"],
        doubleUnderlineNumbers: ["1", "b5"],
        underlinedNumbers: ["b3", "6"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 6,
        y: 1,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#AE96FF",
        degree: "bb7",
        degreeColor: "#FFFF00",
        formulae: [1, 2, 4, 6, 7, 9, 10],
        formulaeOriginal: ["1", "2", "4", "6", "7", "9", "0"],
        numbers: ["1", "b2", "b3", "4", "b5", "b6", "bb7"],
        doubleUnderlineNumbers: ["b3", "bb7"],
        underlinedNumbers: ["1", "b5"],
      },
    },
  },
  "ionian ♯5": {
    1: {
      ArrowUp: {
        x: 2,
        y: 1,
        prevDegree: "3.",
        name: "phrygian",
        nameColor: "#1e62ff",
        degree: "b4",
        degreeColor: "#FF7F00",
        formulae: [1, 2, 4, 5, 8, 9, 11],
        formulaeOriginal: ["1", "2", "4", "5", "8", "9", "A"],
        numbers: ["1", "b2", "b3", "b4", "5", "b6", "b7"],
        underlinedNumbers: ["b2", "5"],
        doubleUnderlineNumbers: ["b4", "b7"],
      },
      ArrowDown: null,
    },
    2: {
      ArrowUp: {
        x: 2,
        y: 2,
        prevDegree: "b3.",
        name: "ionian",
        nameColor: "#FF0000",
        degree: "♯5",
        degreeColor: "#00FF00",
        formulae: [1, 3, 5, 6, 9, 10, 12],
        formulaeOriginal: ["1", "3", "5", "6", "9", "0", "B"],
        numbers: ["1", "2", "3", "4", "♯5", "6", "7"],
        doubleUnderlineNumbers: ["4", "7"],
        underlinedNumbers: ["2", "♯5"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 0,
        y: 0,
        nameColor: "#fff",
        degreeColor: "#fff",
        name: "Hexa",
        degree: "b2",
        formulae: [1, 2, 5, 6, 9, 10],
        formulaeOriginal: ["1", "2", "5", "6", "9", "0"],
        numbers: ["1", "b2", "3", "4", "♯5", "6"],
        squareNumbers: ["b2", "4", "6"],
      },
    },
    3: {
      ArrowUp: {
        x: 1,
        y: 0,
        name: "Whole/half",
        formulae: [1, 3, 4, 6, 7, 9, 10, 12],
        formulaeOriginal: ["1", "3", "4", "6", "7", "9", "0", "B"],
        numbers: ["1", "2", "b3", "4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["2", "b3", "b5", "b6", "bb7", "b8"],
        squareNumbers: ["2", "4", "b6", "b8"],
      },
      ArrowDown: {
        x: 1,
        y: 0,
        name: "Whole/half",
        formulae: [1, 3, 4, 6, 7, 9, 10, 12],
        formulaeOriginal: ["1", "3", "4", "6", "7", "9", "0", "B"],
        numbers: ["1", "2", "b3", "4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["2", "b3", "b5", "b6", "bb7", "b8"],
        squareNumbers: ["2", "4", "b6", "b8"],
      },
    },
    4: {
      ArrowUp: {
        x: 2,
        y: 3,
        prevDegree: "b3.",
        name: "lydian",
        nameColor: "#fff",
        degree: "♯5",
        degreeColor: "#00FF00",
        // secondDegree: "♯5",
        // secondDegreeColor: "#fff",
        formulae: [1, 3, 5, 7, 9, 10, 12],
        formulaeOriginal: ["1", "3", "5", "7", "9", "0", "B"],
        numbers: ["1", "2", "3", "♯4", "♯5", "6", "7"],
        doubleUnderlineNumbers: ["1", "♯4"],
        underlinedNumbers: ["2", "♯5"],
      },
      ArrowDown: null,
    },
    5: {
      ArrowUp: null,
      ArrowDown: {
        x: 0,
        y: 0,
        prevDegree: "1.",
        name: "ionian",
        nameColor: "#FF0000",
        formulae: [1, 3, 5, 6, 8, 10, 12],
        formulaeOriginal: ["1", "3", "5", "6", "8", "0", "B"],
        numbers: ["1", "2", "3", "4", "5", "6", "7"],
        underlinedNumbers: ["4", "7"],
      },
    },
    6: {
      ArrowUp: {
        x: 2,
        y: 2,
        prevDegree: "b3.",
        name: "ionian",
        nameColor: "#FF0000",
        degree: "♯5",
        degreeColor: "#00FF00",
        formulae: [1, 3, 5, 6, 9, 10, 12],
        formulaeOriginal: ["1", "3", "5", "6", "9", "0", "B"],
        numbers: ["1", "2", "3", "4", "♯5", "6", "7"],
        doubleUnderlineNumbers: ["4", "7"],
        underlinedNumbers: ["2", "♯5"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 0,
        y: 1,
        prevDegree: "1.",
        name: "ionian",
        nameColor: "#FF0000",
        degree: "b6",
        degreeColor: "#00FF00",
        formulae: [1, 3, 5, 6, 8, 9, 12],
        formulaeOriginal: ["1", "3", "5", "6", "8", "9", "B"],
        numbers: ["1", "2", "3", "4", "5", "b6", "7"],
        doubleUnderlineNumbers: ["2", "b6"],
        underlinedNumbers: ["4", "7"],
      },
    },
    7: {
      ArrowUp: null,
      ArrowDown: {
        x: 2,
        y: 2,
        prevDegree: "b3.",
        name: "ionian",
        nameColor: "#FF0000",
        degree: "♯5",
        degreeColor: "#00FF00",
        formulae: [1, 3, 5, 6, 9, 10, 12],
        formulaeOriginal: ["1", "3", "5", "6", "9", "0", "B"],
        numbers: ["1", "2", "3", "4", "♯5", "6", "7"],
        doubleUnderlineNumbers: ["4", "7"],
        underlinedNumbers: ["2", "♯5"],
        chromaticFormula: true,
      },
    },
  },
  "dorian ♯4": {
    1: {
      ArrowUp: {
        x: 3,
        y: 2,
        prevDegree: "4.",
        name: "dorian",
        nameColor: "#FFFF00",
        degree: "♯4",
        degreeColor: "#ff00b7",
        formulae: [1, 3, 4, 7, 8, 10, 11],
        formulaeOriginal: ["1", "3", "4", "7", "8", "0", "A"],
        numbers: ["1", "2", "b3", "♯4", "5", "6", "b7"],
        underlinedNumbers: ["1", "♯4"],
        doubleUnderlineNumbers: ["b3", "6"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 0,
        y: 1,
        nameColor: "#fff",
        degreeColor: "#fff",
        name: "Hexa",
        degree: "♯2",
        formulae: [1, 4, 5, 8, 9, 12],
        formulaeOriginal: ["1", "4", "5", "8", "9", "B"],
        numbers: ["1", "♯2", "3", "X4", "♯5", "X6"],
        squareNumbers: ["♯2", "X4", "X6"],
      },
    },
    2: {
      ArrowUp: {
        x: 0,
        y: 0,
        name: "Half/whole",
        formulae: [1, 2, 4, 5, 7, 8, 10, 11],
        formulaeOriginal: ["1", "2", "4", "5", "7", "8", "0", "A"],
        numbers: ["1", "b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        squareNumbers: ["b2", "b4", "bb6", "bb8"],
      },
      ArrowDown: {
        x: 0,
        y: 0,
        name: "Half/whole",
        formulae: [1, 2, 4, 5, 7, 8, 10, 11],
        formulaeOriginal: ["1", "2", "4", "5", "7", "8", "0", "A"],
        numbers: ["1", "b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        squareNumbers: ["b2", "b4", "bb6", "bb8"],
      },
    },
    3: {
      ArrowUp: {
        x: 3,
        y: 3,
        prevDegree: "4.",
        name: "lydian",
        nameColor: "#ff00b7",
        degree: "b7",
        degreeColor: "#FF7F00",
        formulae: [1, 3, 5, 7, 8, 10, 11],
        formulaeOriginal: ["1", "3", "5", "7", "8", "0", "A"],
        numbers: ["1", "2", "3", "♯4", "5", "6", "b7"],
        underlinedNumbers: ["1", "♯4"],
        doubleUnderlineNumbers: ["3", "b7"],
      },
      ArrowDown: null,
    },
    4: {
      ArrowUp: null,
      ArrowDown: {
        x: 1,
        y: 0,
        prevDegree: "2.",
        name: "dorian",
        nameColor: "#FFFF00",
        formulae: [1, 3, 4, 6, 8, 10, 11],
        formulaeOriginal: ["1", "3", "4", "6", "8", "0", "A"],
        numbers: ["1", "2", "b3", "4", "5", "6", "b7"],
        underlinedNumbers: ["b3", "6"],
      },
    },
    5: {
      ArrowUp: {
        x: 3,
        y: 2,
        prevDegree: "4.",
        name: "dorian",
        nameColor: "#FFFF00",
        degree: "♯4",
        degreeColor: "#ff00b7",
        formulae: [1, 3, 4, 7, 8, 10, 11],
        formulaeOriginal: ["1", "3", "4", "7", "8", "0", "A"],
        numbers: ["1", "2", "b3", "♯4", "5", "6", "b7"],
        underlinedNumbers: ["1", "♯4"],
        doubleUnderlineNumbers: ["b3", "6"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 1,
        y: 1,
        prevDegree: "2.",
        name: "dorian",
        nameColor: "#FFFF00",
        degree: "b5",
        degreeColor: "#1e62ff",
        formulae: [1, 3, 4, 6, 7, 10, 11],
        formulaeOriginal: ["1", "3", "4", "6", "7", "0", "A"],
        numbers: ["1", "2", "b3", "4", "b5", "6", "b7"],
        doubleUnderlineNumbers: ["1", "b5"],
        underlinedNumbers: ["b3", "6"],
      },
    },
    6: {
      ArrowUp: null,
      ArrowDown: {
        x: 3,
        y: 2,
        prevDegree: "4.",
        name: "dorian",
        nameColor: "#FFFF00",
        degree: "♯4",
        degreeColor: "#ff00b7",
        formulae: [1, 3, 4, 7, 8, 10, 11],
        formulaeOriginal: ["1", "3", "4", "7", "8", "0", "A"],
        numbers: ["1", "2", "b3", "♯4", "5", "6", "b7"],
        underlinedNumbers: ["1", "♯4"],
        doubleUnderlineNumbers: ["b3", "6"],
        chromaticFormula: true,
      },
    },
    7: {
      ArrowUp: {
        x: 3,
        y: 1,
        prevDegree: "4.",
        name: "lydian",
        nameColor: "#ff00b7",
        degree: "b3",
        degreeColor: "#FFFF00",
        formulae: [1, 3, 4, 7, 8, 10, 12],
        formulaeOriginal: ["1", "3", "4", "7", "8", "0", "B"],
        numbers: ["1", "2", "b3", "♯4", "5", "6", "7"],
        underlinedNumbers: ["1", "♯4"],
        doubleUnderlineNumbers: ["b3", "6"],
      },
      ArrowDown: null,
    },
  },
  "phrygian ♮3": {
    1: {
      ArrowUp: {
        x: 0,
        y: 0,
        name: "Half/whole",
        formulae: [1, 2, 4, 5, 7, 8, 10, 11],
        formulaeOriginal: ["1", "2", "4", "5", "7", "8", "0", "A"],
        numbers: ["1", "b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        squareNumbers: ["b2", "b4", "bb6", "bb8"],
      },
      ArrowDown: {
        x: 1,
        y: 0,
        name: "Whole/half",
        formulae: [1, 3, 4, 6, 7, 9, 10, 12],
        formulaeOriginal: ["1", "3", "4", "6", "7", "9", "0", "B"],
        numbers: ["1", "2", "b3", "4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["2", "b3", "b5", "b6", "bb7", "b8"],
        squareNumbers: ["2", "4", "b6", "b8"],
      },
    },
    2: {
      ArrowUp: {
        x: 4,
        y: 3,
        prevDegree: "b5.",
        name: "mixo",
        nameColor: "#FF7F00",
        degree: "b6",
        degreeColor: "#00FF00",
        formulae: [1, 3, 5, 6, 8, 9, 11],
        formulaeOriginal: ["1", "3", "5", "6", "8", "9", "A"],
        numbers: ["1", "2", "3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["b7", "3"],
        doubleUnderlineNumbers: ["2", "b6"],
      },
      ArrowDown: null,
    },
    3: {
      ArrowUp: null,
      ArrowDown: {
        x: 2,
        y: 0,
        prevDegree: "3.",
        name: "phrygian",
        nameColor: "#1e62ff",
        formulae: [1, 2, 4, 6, 8, 9, 11],
        formulaeOriginal: ["1", "2", "4", "6", "8", "9", "A"],
        numbers: ["1", "b2", "b3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["b2", "5"],
      },
    },
    4: {
      ArrowUp: {
        x: 4,
        y: 2,
        prevDegree: "5.",
        name: "phrygian",
        nameColor: "#1e62ff",
        degree: "♮3",
        degreeColor: "#ff7f00",
        formulae: [1, 2, 5, 6, 8, 9, 11],
        formulaeOriginal: ["1", "2", "5", "6", "8", "9", "A"],
        numbers: ["1", "b2", "3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["3", "b7"],
        doubleUnderlineNumbers: ["b2", "5"],
      },
      ArrowDown: {
        x: 2,
        y: 1,
        prevDegree: "3.",
        name: "phrygian",
        nameColor: "#1e62ff",
        degree: "b4",
        degreeColor: "#FF7F00",
        formulae: [1, 2, 4, 5, 8, 9, 11],
        formulaeOriginal: ["1", "2", "4", "5", "8", "9", "A"],
        numbers: ["1", "b2", "b3", "b4", "5", "b6", "b7"],
        underlinedNumbers: ["b2", "5"],
        doubleUnderlineNumbers: ["b4", "b7"],
      },
    },
    5: {
      ArrowUp: null,
      ArrowDown: {
        x: 4,
        y: 2,
        prevDegree: "5.",
        name: "phrygian",
        nameColor: "#1e62ff",
        degree: "♮3",
        degreeColor: "#ff7f00",
        formulae: [1, 2, 5, 6, 8, 9, 11],
        formulaeOriginal: ["1", "2", "5", "6", "8", "9", "A"],
        numbers: ["1", "b2", "3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["3", "b7"],
        doubleUnderlineNumbers: ["b2", "5"],
      },
    },
    6: {
      ArrowUp: {
        x: 4,
        y: 1,
        prevDegree: "5.",
        name: "mixo",
        nameColor: "#FF7F00",
        degree: "b2",
        degreeColor: "#1e62ff",
        formulae: [1, 2, 5, 6, 8, 10, 11],
        formulaeOriginal: ["1", "2", "5", "6", "8", "0", "A"],
        numbers: ["1", "b2", "3", "4", "5", "6", "b7"],
        doubleUnderlineNumbers: ["b2", "5"],
        underlinedNumbers: ["3", "b7"],
      },
      ArrowDown: null,
    },
    7: {
      ArrowUp: {
        x: 4,
        y: 2,
        prevDegree: "5.",
        name: "phrygian",
        nameColor: "#1e62ff",
        degree: "♮3",
        degreeColor: "#ff7f00",
        formulae: [1, 2, 5, 6, 8, 9, 11],
        formulaeOriginal: ["1", "2", "5", "6", "8", "9", "A"],
        numbers: ["1", "b2", "3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["3", "b7"],
        doubleUnderlineNumbers: ["b2", "5"],
      },
      ArrowDown: {
        x: 0,
        y: 0,
        nameColor: "#fff",
        degreeColor: "#fff",
        name: "Hexa",
        degree: "b2",
        formulae: [1, 2, 5, 6, 9, 10],
        formulaeOriginal: ["1", "2", "5", "6", "9", "0"],
        numbers: ["1", "b2", "3", "4", "♯5", "6"],
        squareNumbers: ["b2", "4", "6"],
      },
    },
  },
  "lydian ♯2": {
    1: {
      ArrowUp: {
        x: 5,
        y: 3,
        prevDegree: "6.",
        name: "aeolian",
        nameColor: "#AE96FF",
        degree: "b5",
        degreeColor: "#00FF00",
        formulae: [1, 3, 4, 6, 7, 9, 11],
        formulaeOriginal: ["1", "3", "4", "6", "7", "9", "A"],
        numbers: ["1", "2", "b3", "4", "b5", "b6", "b7"],
        doubleUnderlineNumbers: ["1", "b5"],
        underlinedNumbers: ["2", "b6"],
      },
      ArrowDown: null,
    },
    2: {
      ArrowUp: null,
      ArrowDown: {
        x: 3,
        y: 0,
        prevDegree: "4.",
        name: "lydian",
        nameColor: "#ff00b7",
        formulae: [1, 3, 5, 7, 8, 10, 12],
        formulaeOriginal: ["1", "3", "5", "7", "8", "0", "B"],
        numbers: ["1", "2", "3", "♯4", "5", "6", "7"],
        underlinedNumbers: ["1", "♯4"],
      },
    },
    3: {
      ArrowUp: {
        x: 5,
        y: 2,
        prevDegree: "b6.",
        name: "lydian",
        nameColor: "#ff00b7",
        degree: "♯2",
        degreeColor: "#FFFF00",
        formulae: [1, 4, 5, 7, 8, 10, 12],
        formulaeOriginal: ["1", "4", "5", "7", "8", "0", "B"],
        numbers: ["1", "♯2", "3", "♯4", "5", "6", "7"],
        doubleUnderlineNumbers: ["1", "♯4"],
        underlinedNumbers: ["♯2", "6"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 3,
        y: 1,
        prevDegree: "4.",
        name: "lydian",
        nameColor: "#ff00b7",
        degree: "b3",
        degreeColor: "#FFFF00",
        formulae: [1, 3, 4, 7, 8, 10, 12],
        formulaeOriginal: ["1", "3", "4", "7", "8", "0", "B"],
        numbers: ["1", "2", "b3", "♯4", "5", "6", "7"],
        underlinedNumbers: ["1", "♯4"],
        doubleUnderlineNumbers: ["b3", "6"],
      },
    },
    4: {
      ArrowUp: null,
      ArrowDown: {
        x: 5,
        y: 2,
        prevDegree: "b6.",
        name: "lydian",
        nameColor: "#ff00b7",
        degree: "♯2",
        degreeColor: "#FFFF00",
        formulae: [1, 4, 5, 7, 8, 10, 12],
        formulaeOriginal: ["1", "4", "5", "7", "8", "0", "B"],
        numbers: ["1", "♯2", "3", "♯4", "5", "6", "7"],
        doubleUnderlineNumbers: ["1", "♯4"],
        underlinedNumbers: ["♯2", "6"],
        chromaticFormula: true,
      },
    },
    5: {
      ArrowUp: {
        x: 5,
        y: 1,
        prevDegree: "b6.",
        name: "lydian",
        nameColor: "#FFFFFF",
        degree: "♯2",
        degreeColor: "#FFFF00",
        secondDegree: "♯5",
        secondDegreeColor: "#fff",
        formulae: [1, 4, 5, 7, 9, 10, 12],
        formulaeOriginal: ["1", "4", "5", "7", "9", "0", "B"],
        numbers: ["1", "♯2", "3", "♯4", "♯5", "6", "7"],
        doubleUnderlineNumbers: ["1", "♯4"],
        underlinedNumbers: ["♯2", "6"],
      },
      ArrowDown: null,
    },
    6: {
      ArrowUp: {
        x: 5,
        y: 1,
        prevDegree: "b6.",
        name: "lydian",
        nameColor: "#FFFFFF",
        degree: "♯2",
        degreeColor: "#FFFF00",
        secondDegree: "♯5",
        secondDegreeColor: "#fff",
        formulae: [1, 4, 5, 7, 9, 10, 12],
        formulaeOriginal: ["1", "4", "5", "7", "9", "0", "B"],
        numbers: ["1", "♯2", "3", "♯4", "♯5", "6", "7"],
        doubleUnderlineNumbers: ["1", "♯4"],
        underlinedNumbers: ["♯2", "6"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 0,
        y: 1,
        nameColor: "#fff",
        degreeColor: "#fff",
        name: "Hexa",
        degree: "♯2",
        formulae: [1, 4, 5, 8, 9, 12],
        formulaeOriginal: ["1", "4", "5", "8", "9", "B"],
        numbers: ["1", "♯2", "3", "X4", "♯5", "X6"],
        squareNumbers: ["♯2", "X4", "X6"],
      },
    },
    7: {
      ArrowUp: {
        x: 0,
        y: 0,
        name: "Half/whole",
        formulae: [1, 2, 4, 5, 7, 8, 10, 11],
        formulaeOriginal: ["1", "2", "4", "5", "7", "8", "0", "A"],
        numbers: ["1", "b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        squareNumbers: ["b2", "b4", "bb6", "bb8"],
      },
      ArrowDown: {
        x: 0,
        y: 0,
        name: "Half/whole",
        formulae: [1, 2, 4, 5, 7, 8, 10, 11],
        formulaeOriginal: ["1", "2", "4", "5", "7", "8", "0", "A"],
        numbers: ["1", "b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        squareNumbers: ["b2", "b4", "bb6", "bb8"],
      },
    },
  },
  "locrian b4 bb7": {
    1: {
      ArrowUp: null,
      ArrowDown: {
        x: 4,
        y: 0,
        prevDegree: "5.",
        name: "mixo",
        nameColor: "#FF7F00",
        formulae: [1, 3, 5, 6, 8, 10, 11],
        formulaeOriginal: ["1", "3", "5", "6", "8", "0", "A"],
        numbers: ["1", "2", "3", "4", "5", "6", "b7"],
        underlinedNumbers: ["3", "b7"],
      },
    },
    2: {
      ArrowUp: {
        x: 6,
        y: 2,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#fff",
        degree: "b4",
        degreeColor: "#fff",
        secondDegree: "bb7",
        secondDegreeColor: "#FFFF00",
        text: "(Altered bb7)",
        formulae: [1, 2, 4, 5, 7, 9, 10],
        formulaeOriginal: ["1", "2", "4", "5", "7", "9", "0"],
        numbers: ["1", "b2", "b3", "b4", "b5", "b6", "bb7"],
        underlinedNumbers: ["1", "b5"],
        doubleUnderlineNumbers: ["b3", "bb7"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 4,
        y: 1,
        prevDegree: "5.",
        name: "mixo",
        nameColor: "#FF7F00",
        degree: "b2",
        degreeColor: "#1e62ff",
        formulae: [1, 2, 5, 6, 8, 10, 11],
        formulaeOriginal: ["1", "2", "5", "6", "8", "0", "A"],
        numbers: ["1", "b2", "3", "4", "5", "6", "b7"],
        doubleUnderlineNumbers: ["b2", "5"],
        underlinedNumbers: ["3", "b7"],
      },
    },
    3: {
      ArrowUp: null,
      ArrowDown: {
        x: 6,
        y: 2,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#fff",
        degree: "b4",
        degreeColor: "#fff",
        secondDegree: "bb7",
        secondDegreeColor: "#FFFF00",
        text: "(Altered bb7)",
        formulae: [1, 2, 4, 5, 7, 9, 10],
        formulaeOriginal: ["1", "2", "4", "5", "7", "9", "0"],
        numbers: ["1", "b2", "b3", "b4", "b5", "b6", "bb7"],
        underlinedNumbers: ["1", "b5"],
        doubleUnderlineNumbers: ["b3", "bb7"],
        chromaticFormula: true,
      },
    },
    4: {
      ArrowUp: {
        x: 6,
        y: 1,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#AE96FF",
        degree: "bb7",
        degreeColor: "#FFFF00",
        formulae: [1, 2, 4, 6, 7, 9, 10],
        formulaeOriginal: ["1", "2", "4", "6", "7", "9", "0"],
        numbers: ["1", "b2", "b3", "4", "b5", "b6", "bb7"],
        doubleUnderlineNumbers: ["b3", "bb7"],
        underlinedNumbers: ["1", "b5"],
      },
      ArrowDown: null,
    },
    5: {
      ArrowUp: {
        x: 6,
        y: 2,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#fff",
        degree: "b4",
        degreeColor: "#fff",
        secondDegree: "bb7",
        secondDegreeColor: "#FFFF00",
        text: "(Altered bb7)",
        formulae: [1, 2, 4, 5, 7, 9, 10],
        formulaeOriginal: ["1", "2", "4", "5", "7", "9", "0"],
        numbers: ["1", "b2", "b3", "b4", "b5", "b6", "bb7"],
        underlinedNumbers: ["1", "b5"],
        doubleUnderlineNumbers: ["b3", "bb7"],
        chromaticFormula: true,
      },
      ArrowDown: {
        x: 0,
        y: 0,
        nameColor: "#fff",
        degreeColor: "#fff",
        name: "Hexa",
        degree: "b2",
        formulae: [1, 2, 5, 6, 9, 10],
        formulaeOriginal: ["1", "2", "5", "6", "9", "0"],
        numbers: ["1", "b2", "3", "4", "♯5", "6"],
        squareNumbers: ["b2", "4", "6"],
      },
    },
    6: {
      ArrowUp: {
        x: 0,
        y: 0,
        name: "Half/whole",
        formulae: [1, 2, 4, 5, 7, 8, 10, 11],
        formulaeOriginal: ["1", "2", "4", "5", "7", "8", "0", "A"],
        numbers: ["1", "b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        squareNumbers: ["b2", "b4", "bb6", "bb8"],
      },
      ArrowDown: {
        x: 0,
        y: 0,
        name: "Half/whole",
        formulae: [1, 2, 4, 5, 7, 8, 10, 11],
        formulaeOriginal: ["1", "2", "4", "5", "7", "8", "0", "A"],
        numbers: ["1", "b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        squareNumbers: ["b2", "b4", "bb6", "bb8"],
      },
    },
    7: {
      ArrowUp: {
        x: 6,
        y: 3,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#fff",
        degree: "b4",
        degreeColor: "#FF7F00",
        text: "(Altered Dominant)",
        formulae: [1, 2, 4, 5, 7, 9, 11],
        formulaeOriginal: ["1", "2", "4", "5", "7", "9", "A"],
        numbers: ["1", "b2", "b3", "b4", "b5", "b6", "b7"],
        underlinedNumbers: ["1", "b5"],
        doubleUnderlineNumbers: ["b4", "b7"],
      },
      ArrowDown: null,
    },
  },
  "ionian b6": {
    1: {
      ArrowUp: {
        x: 0,
        y: 0,
        name: "Half/whole",
        formulae: [1, 2, 4, 5, 7, 8, 10, 11],
        formulaeOriginal: ["1", "2", "4", "5", "7", "8", "0", "A"],
        numbers: ["1", "b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        squareNumbers: ["b2", "b4", "bb6", "bb8"],
      },
      ArrowDown: null,
    },
    2: {
      ArrowUp: {
        x: 0,
        y: 1,
        nameColor: "#fff",
        degreeColor: "#fff",
        name: "Hexa",
        degree: "♯2",
        formulae: [1, 4, 5, 8, 9, 12],
        formulaeOriginal: ["1", "4", "5", "8", "9", "B"],
        numbers: ["1", "♯2", "3", "X4", "♯5", "X6"],
        squareNumbers: ["♯2", "X4", "X6"],
      },
      ArrowDown: {
        x: 0,
        y: 1,
        prevDegree: "1.",
        name: "ionian",
        nameColor: "#FF0000",
        degree: "b6",
        degreeColor: "#00FF00",
        formulae: [1, 3, 5, 6, 8, 9, 12],
        formulaeOriginal: ["1", "3", "5", "6", "8", "9", "B"],
        numbers: ["1", "2", "3", "4", "5", "b6", "7"],
        doubleUnderlineNumbers: ["2", "b6"],
        underlinedNumbers: ["4", "7"],
        chromaticFormula: true,
      },
    },
    3: {
      ArrowUp: null,
      ArrowDown: {
        x: 0,
        y: 2,
        prevDegree: "1.",
        name: "aeolian",
        nameColor: "#00FF00",
        degree: "♮7",
        degreeColor: "#FF0000",
        formulae: [1, 3, 4, 6, 8, 9, 12],
        formulaeOriginal: ["1", "3", "4", "6", "8", "9", "B"],
        numbers: ["1", "2", "b3", "4", "5", "b6", "7"],
        underlinedNumbers: ["4", "7"],
        doubleUnderlineNumbers: ["2", "b6"],
      },
    },
    4: {
      ArrowUp: {
        x: 0,
        y: 1,
        prevDegree: "1.",
        name: "ionian",
        nameColor: "#FF0000",
        degree: "b6",
        degreeColor: "#00FF00",
        formulae: [1, 3, 5, 6, 8, 9, 12],
        formulaeOriginal: ["1", "3", "5", "6", "8", "9", "B"],
        numbers: ["1", "2", "3", "4", "5", "b6", "7"],
        doubleUnderlineNumbers: ["2", "b6"],
        underlinedNumbers: ["4", "7"],
        chromaticFormula: true,
      },
      ArrowDown: null,
    },
    5: {
      ArrowUp: {
        x: 2,
        y: 2,
        prevDegree: "b3.",
        name: "ionian",
        nameColor: "#FF0000",
        degree: "♯5",
        degreeColor: "#00FF00",
        formulae: [1, 3, 5, 6, 9, 10, 12],
        formulaeOriginal: ["1", "3", "5", "6", "9", "0", "B"],
        numbers: ["1", "2", "3", "4", "♯5", "6", "7"],
        doubleUnderlineNumbers: ["4", "7"],
        underlinedNumbers: ["2", "♯5"],
      },
      ArrowDown: {
        x: 0,
        y: 1,
        prevDegree: "1.",
        name: "ionian",
        nameColor: "#FF0000",
        degree: "b6",
        degreeColor: "#00FF00",
        formulae: [1, 3, 5, 6, 8, 9, 12],
        formulaeOriginal: ["1", "3", "5", "6", "8", "9", "B"],
        numbers: ["1", "2", "3", "4", "5", "b6", "7"],
        doubleUnderlineNumbers: ["2", "b6"],
        underlinedNumbers: ["4", "7"],
        chromaticFormula: true,
      },
    },
    6: {
      ArrowUp: {
        x: 0,
        y: 0,
        prevDegree: "1.",
        name: "ionian",
        nameColor: "#FF0000",
        formulae: [1, 3, 5, 6, 8, 10, 12],
        formulaeOriginal: ["1", "3", "5", "6", "8", "0", "B"],
        numbers: ["1", "2", "3", "4", "5", "6", "7"],
        underlinedNumbers: ["4", "7"],
      },
      ArrowDown: null,
    },
    7: {
      ArrowUp: null,
      ArrowDown: {
        x: 4,
        y: 3,
        prevDegree: "b5.",
        name: "mixo",
        nameColor: "#FF7F00",
        degree: "b6",
        degreeColor: "#00FF00",
        formulae: [1, 3, 5, 6, 8, 9, 11],
        formulaeOriginal: ["1", "3", "5", "6", "8", "9", "A"],
        numbers: ["1", "2", "3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["b7", "3"],
        doubleUnderlineNumbers: ["2", "b6"],
      },
    },
  },
  "dorian b5": {
    1: {
      ArrowUp: {
        x: 0,
        y: 0,
        nameColor: "#fff",
        degreeColor: "#fff",
        name: "Hexa",
        degree: "b2",
        formulae: [1, 2, 5, 6, 9, 10],
        formulaeOriginal: ["1", "2", "5", "6", "9", "0"],
        numbers: ["1", "b2", "3", "4", "♯5", "6"],
        squareNumbers: ["b2", "4", "6"],
      },
      ArrowDown: {
        x: 1,
        y: 1,
        prevDegree: "2.",
        name: "dorian",
        nameColor: "#FFFF00",
        degree: "b5",
        degreeColor: "#1e62ff",
        formulae: [1, 3, 4, 6, 7, 10, 11],
        formulaeOriginal: ["1", "3", "4", "6", "7", "0", "A"],
        numbers: ["1", "2", "b3", "4", "b5", "6", "b7"],
        doubleUnderlineNumbers: ["1", "b5"],
        underlinedNumbers: ["b3", "6"],
        chromaticFormula: true,
      },
    },
    2: {
      ArrowUp: null,
      ArrowDown: {
        x: 1,
        y: 2,
        prevDegree: "2.",
        name: "locrian",
        nameColor: "#AE96FF",
        degree: "♮6",
        degreeColor: "#FFFF00",
        formulae: [1, 2, 4, 6, 7, 10, 11],
        formulaeOriginal: ["1", "2", "4", "6", "7", "0", "A"],
        numbers: ["1", "b2", "b3", "4", "b5", "6", "b7"],
        doubleUnderlineNumbers: ["1", "b5"],
        underlinedNumbers: ["b3", "6"],
      },
    },
    3: {
      ArrowUp: {
        x: 1,
        y: 1,
        prevDegree: "2.",
        name: "dorian",
        nameColor: "#FFFF00",
        degree: "b5",
        degreeColor: "#1e62ff",
        formulae: [1, 3, 4, 6, 7, 10, 11],
        formulaeOriginal: ["1", "3", "4", "6", "7", "0", "A"],
        numbers: ["1", "2", "b3", "4", "b5", "6", "b7"],
        doubleUnderlineNumbers: ["1", "b5"],
        underlinedNumbers: ["b3", "6"],
        chromaticFormula: true,
      },
      ArrowDown: null,
    },
    4: {
      ArrowUp: {
        x: 3,
        y: 2,
        prevDegree: "4.",
        name: "dorian",
        nameColor: "#FFFF00",
        degree: "♯4",
        degreeColor: "#ff00b7",
        formulae: [1, 3, 4, 7, 8, 10, 11],
        formulaeOriginal: ["1", "3", "4", "7", "8", "0", "A"],
        numbers: ["1", "2", "b3", "♯4", "5", "6", "b7"],
        underlinedNumbers: ["1", "♯4"],
        doubleUnderlineNumbers: ["b3", "6"],
      },
      ArrowDown: {
        x: 1,
        y: 1,
        prevDegree: "2.",
        name: "dorian",
        nameColor: "#FFFF00",
        degree: "b5",
        degreeColor: "#1e62ff",
        formulae: [1, 3, 4, 6, 7, 10, 11],
        formulaeOriginal: ["1", "3", "4", "6", "7", "0", "A"],
        numbers: ["1", "2", "b3", "4", "b5", "6", "b7"],
        doubleUnderlineNumbers: ["1", "b5"],
        underlinedNumbers: ["b3", "6"],
        chromaticFormula: true,
      },
    },
    5: {
      ArrowUp: {
        x: 1,
        y: 0,
        prevDegree: "2.",
        name: "dorian",
        nameColor: "#FFFF00",
        formulae: [1, 3, 4, 6, 8, 10, 11],
        formulaeOriginal: ["1", "3", "4", "6", "8", "0", "A"],
        numbers: ["1", "2", "b3", "4", "5", "6", "b7"],
        underlinedNumbers: ["b3", "6"],
      },
      ArrowDown: null,
    },
    6: {
      ArrowUp: null,
      ArrowDown: {
        x: 5,
        y: 3,
        prevDegree: "6.",
        name: "aeolian",
        nameColor: "#AE96FF",
        degree: "b5",
        degreeColor: "#00FF00",
        formulae: [1, 3, 4, 6, 7, 9, 11],
        formulaeOriginal: ["1", "3", "4", "6", "7", "9", "A"],
        numbers: ["1", "2", "b3", "4", "b5", "b6", "b7"],
        doubleUnderlineNumbers: ["1", "b5"],
        underlinedNumbers: ["2", "b6"],
      },
    },
    7: {
      ArrowUp: {
        x: 1,
        y: 0,
        name: "Whole/half",
        formulae: [1, 3, 4, 6, 7, 9, 10, 12],
        formulaeOriginal: ["1", "3", "4", "6", "7", "9", "0", "B"],
        numbers: ["1", "2", "b3", "4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["2", "b3", "b5", "b6", "bb7", "b8"],
        squareNumbers: ["2", "4", "b6", "b8"],
      },
      ArrowDown: null,
    },
  },
  "phrygian b4": {
    1: {
      ArrowUp: null,
      ArrowDown: {
        x: 2,
        y: 2,
        prevDegree: "b3.",
        name: "ionian",
        nameColor: "#FF0000",
        degree: "♯5",
        degreeColor: "#00FF00",
        formulae: [1, 3, 5, 6, 9, 10, 12],
        formulaeOriginal: ["1", "3", "5", "6", "9", "0", "B"],
        numbers: ["1", "2", "3", "4", "♯5", "6", "7"],
        doubleUnderlineNumbers: ["4", "7"],
        underlinedNumbers: ["2", "♯5"],
      },
    },
    2: {
      ArrowUp: {
        x: 2,
        y: 1,
        prevDegree: "3.",
        name: "phrygian",
        nameColor: "#1e62ff",
        degree: "b4",
        degreeColor: "#FF7F00",
        formulae: [1, 2, 4, 5, 8, 9, 11],
        formulaeOriginal: ["1", "2", "4", "5", "8", "9", "A"],
        numbers: ["1", "b2", "b3", "b4", "5", "b6", "b7"],
        underlinedNumbers: ["b2", "5"],
        doubleUnderlineNumbers: ["b4", "b7"],
        chromaticFormula: true,
      },
      ArrowDown: null,
    },
    3: {
      ArrowUp: {
        x: 4,
        y: 2,
        prevDegree: "5.",
        name: "phrygian",
        nameColor: "#1e62ff",
        degree: "♮3",
        degreeColor: "#ff7f00",
        formulae: [1, 2, 5, 6, 8, 9, 11],
        formulaeOriginal: ["1", "2", "5", "6", "8", "9", "A"],
        numbers: ["1", "b2", "3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["3", "b7"],
        doubleUnderlineNumbers: ["b2", "5"],
      },
      ArrowDown: {
        x: 2,
        y: 1,
        prevDegree: "3.",
        name: "phrygian",
        nameColor: "#1e62ff",
        degree: "b4",
        degreeColor: "#FF7F00",
        formulae: [1, 2, 4, 5, 8, 9, 11],
        formulaeOriginal: ["1", "2", "4", "5", "8", "9", "A"],
        numbers: ["1", "b2", "b3", "b4", "5", "b6", "b7"],
        underlinedNumbers: ["b2", "5"],
        doubleUnderlineNumbers: ["b4", "b7"],
        chromaticFormula: true,
      },
    },
    4: {
      ArrowUp: {
        x: 2,
        y: 0,
        prevDegree: "3.",
        name: "phrygian",
        nameColor: "#1e62ff",
        formulae: [1, 2, 4, 6, 8, 9, 11],
        formulaeOriginal: ["1", "2", "4", "6", "8", "9", "A"],
        numbers: ["1", "b2", "b3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["b2", "5"],
      },
      ArrowDown: null,
    },
    5: {
      ArrowUp: null,
      ArrowDown: {
        x: 6,
        y: 3,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#fff",
        degree: "b4",
        degreeColor: "#FF7F00",
        text: "(Altered Dominant)",
        formulae: [1, 2, 4, 5, 7, 9, 11],
        formulaeOriginal: ["1", "2", "4", "5", "7", "9", "A"],
        numbers: ["1", "b2", "b3", "b4", "b5", "b6", "b7"],
        underlinedNumbers: ["1", "b5"],
        doubleUnderlineNumbers: ["b4", "b7"],
      },
    },
    6: {
      ArrowUp: {
        x: 0,
        y: 0,
        name: "Half/whole",
        formulae: [1, 2, 4, 5, 7, 8, 10, 11],
        formulaeOriginal: ["1", "2", "4", "5", "7", "8", "0", "A"],
        numbers: ["1", "b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        squareNumbers: ["b2", "b4", "bb6", "bb8"],
      },
      ArrowDown: null,
    },
    7: {
      ArrowUp: {
        x: 0,
        y: 1,
        nameColor: "#fff",
        degreeColor: "#fff",
        name: "Hexa",
        degree: "♯2",
        formulae: [1, 4, 5, 8, 9, 12],
        formulaeOriginal: ["1", "4", "5", "8", "9", "B"],
        numbers: ["1", "♯2", "3", "X4", "♯5", "X6"],
        squareNumbers: ["♯2", "X4", "X6"],
      },
      ArrowDown: {
        x: 2,
        y: 1,
        prevDegree: "3.",
        name: "phrygian",
        nameColor: "#1e62ff",
        degree: "b4",
        degreeColor: "#FF7F00",
        formulae: [1, 2, 4, 5, 8, 9, 11],
        formulaeOriginal: ["1", "2", "4", "5", "8", "9", "A"],
        numbers: ["1", "b2", "b3", "b4", "5", "b6", "b7"],
        underlinedNumbers: ["b2", "5"],
        doubleUnderlineNumbers: ["b4", "b7"],
        chromaticFormula: true,
      },
    },
  },
  "lydian b3": {
    1: {
      ArrowUp: {
        x: 3,
        y: 1,
        prevDegree: "4.",
        name: "lydian",
        nameColor: "#ff00b7",
        degree: "b3",
        degreeColor: "#FFFF00",
        formulae: [1, 3, 4, 7, 8, 10, 12],
        formulaeOriginal: ["1", "3", "4", "7", "8", "0", "B"],
        numbers: ["1", "2", "b3", "♯4", "5", "6", "7"],
        underlinedNumbers: ["1", "♯4"],
        doubleUnderlineNumbers: ["b3", "6"],
        chromaticFormula: true,
      },
      ArrowDown: null,
    },
    2: {
      ArrowUp: {
        x: 5,
        y: 2,
        prevDegree: "b6.",
        name: "lydian",
        nameColor: "#ff00b7",
        degree: "♯2",
        degreeColor: "#FFFF00",
        formulae: [1, 4, 5, 7, 8, 10, 12],
        formulaeOriginal: ["1", "4", "5", "7", "8", "0", "B"],
        numbers: ["1", "♯2", "3", "♯4", "5", "6", "7"],
        doubleUnderlineNumbers: ["1", "♯4"],
        underlinedNumbers: ["♯2", "6"],
      },
      ArrowDown: {
        x: 3,
        y: 1,
        prevDegree: "4.",
        name: "lydian",
        nameColor: "#ff00b7",
        degree: "b3",
        degreeColor: "#FFFF00",
        formulae: [1, 3, 4, 7, 8, 10, 12],
        formulaeOriginal: ["1", "3", "4", "7", "8", "0", "B"],
        numbers: ["1", "2", "b3", "♯4", "5", "6", "7"],
        underlinedNumbers: ["1", "♯4"],
        doubleUnderlineNumbers: ["b3", "6"],
        chromaticFormula: true,
      },
    },
    3: {
      ArrowUp: {
        x: 3,
        y: 0,
        prevDegree: "4.",
        name: "lydian",
        nameColor: "#ff00b7",
        formulae: [1, 3, 5, 7, 8, 10, 12],
        formulaeOriginal: ["1", "3", "5", "7", "8", "0", "B"],
        numbers: ["1", "2", "3", "♯4", "5", "6", "7"],
        underlinedNumbers: ["1", "♯4"],
      },
      ArrowDown: null,
    },
    4: {
      ArrowUp: null,
      ArrowDown: {
        x: 0,
        y: 3,
        prevDegree: "1.",
        name: "ionian",
        nameColor: "#FF0000",
        degree: "b3",
        degreeColor: "#FFFF00",
        formulae: [1, 3, 4, 6, 8, 10, 12],
        formulaeOriginal: ["1", "3", "4", "6", "8", "0", "B"],
        numbers: ["1", "2", "b3", "4", "5", "6", "7"],
        doubleUnderlineNumbers: ["b3", "6"],
        underlinedNumbers: ["4", "7"],
      },
    },
    5: {
      ArrowUp: {
        x: 1,
        y: 0,
        name: "Whole/half",
        formulae: [1, 3, 4, 6, 7, 9, 10, 12],
        formulaeOriginal: ["1", "3", "4", "6", "7", "9", "0", "B"],
        numbers: ["1", "2", "b3", "4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["2", "b3", "b5", "b6", "bb7", "b8"],
        squareNumbers: ["2", "4", "b6", "b8"],
      },
      ArrowDown: null,
    },
    6: {
      ArrowUp: {
        x: 0,
        y: 1,
        nameColor: "#fff",
        degreeColor: "#fff",
        name: "Hexa",
        degree: "♯2",
        formulae: [1, 4, 5, 8, 9, 12],
        formulaeOriginal: ["1", "4", "5", "8", "9", "B"],
        numbers: ["1", "♯2", "3", "X4", "♯5", "X6"],
        squareNumbers: ["♯2", "X4", "X6"],
      },
      ArrowDown: {
        x: 3,
        y: 1,
        prevDegree: "4.",
        name: "lydian",
        nameColor: "#ff00b7",
        degree: "b3",
        degreeColor: "#FFFF00",
        formulae: [1, 3, 4, 7, 8, 10, 12],
        formulaeOriginal: ["1", "3", "4", "7", "8", "0", "B"],
        numbers: ["1", "2", "b3", "♯4", "5", "6", "7"],
        underlinedNumbers: ["1", "♯4"],
        doubleUnderlineNumbers: ["b3", "6"],
        chromaticFormula: true,
      },
    },
    7: {
      ArrowUp: null,
      ArrowDown: {
        x: 3,
        y: 2,
        prevDegree: "4.",
        name: "dorian",
        nameColor: "#FFFF00",
        degree: "♯4",
        degreeColor: "#ff00b7",
        formulae: [1, 3, 4, 7, 8, 10, 11],
        formulaeOriginal: ["1", "3", "4", "7", "8", "0", "A"],
        numbers: ["1", "2", "b3", "♯4", "5", "6", "b7"],
        underlinedNumbers: ["1", "♯4"],
        doubleUnderlineNumbers: ["b3", "6"],
      },
    },
  },
  "mixo b2": {
    1: {
      ArrowUp: {
        x: 6,
        y: 2,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#fff",
        degree: "b4",
        degreeColor: "#fff",
        secondDegree: "bb7",
        secondDegreeColor: "#FFFF00",
        text: "(Altered bb7)",
        formulae: [1, 2, 4, 5, 7, 9, 10],
        formulaeOriginal: ["1", "2", "4", "5", "7", "9", "0"],
        numbers: ["1", "b2", "b3", "b4", "b5", "b6", "bb7"],
        underlinedNumbers: ["1", "b5"],
        doubleUnderlineNumbers: ["b3", "bb7"],
      },
      ArrowDown: {
        x: 4,
        y: 1,
        prevDegree: "5.",
        name: "mixo",
        nameColor: "#FF7F00",
        degree: "b2",
        degreeColor: "#1e62ff",
        formulae: [1, 2, 5, 6, 8, 10, 11],
        formulaeOriginal: ["1", "2", "5", "6", "8", "0", "A"],
        numbers: ["1", "b2", "3", "4", "5", "6", "b7"],
        doubleUnderlineNumbers: ["b2", "5"],
        underlinedNumbers: ["3", "b7"],
        chromaticFormula: true,
      },
    },
    2: {
      ArrowUp: {
        x: 4,
        y: 0,
        prevDegree: "5.",
        name: "mixo",
        nameColor: "#FF7F00",
        formulae: [1, 3, 5, 6, 8, 10, 11],
        formulaeOriginal: ["1", "3", "5", "6", "8", "0", "A"],
        numbers: ["1", "2", "3", "4", "5", "6", "b7"],
        underlinedNumbers: ["3", "b7"],
      },
      ArrowDown: null,
    },
    3: {
      ArrowUp: null,
      ArrowDown: {
        x: 1,
        y: 3,
        prevDegree: "2.",
        name: "dorian",
        nameColor: "#FFFF00",
        degree: "b2",
        degreeColor: "#1e62ff",
        formulae: [1, 2, 4, 6, 8, 10, 11],
        formulaeOriginal: ["1", "3", "4", "6", "8", "0", "B"],
        numbers: ["1", "2", "b3", "4", "b5", "6", "b7"],
        doubleUnderlineNumbers: ["2", "b5"],
        underlinedNumbers: ["b3", "6"],
      },
    },
    4: {
      ArrowUp: {
        x: 0,
        y: 0,
        name: "Half/whole",
        formulae: [1, 2, 4, 5, 7, 8, 10, 11],
        formulaeOriginal: ["1", "2", "4", "5", "7", "8", "0", "A"],
        numbers: ["1", "b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
        squareNumbers: ["b2", "b4", "bb6", "bb8"],
      },
      ArrowDown: null,
    },
    5: {
      ArrowUp: {
        x: 0,
        y: 0,
        nameColor: "#fff",
        degreeColor: "#fff",
        name: "Hexa",
        degree: "b2",
        formulae: [1, 2, 5, 6, 9, 10],
        formulaeOriginal: ["1", "2", "5", "6", "9", "0"],
        numbers: ["1", "b2", "3", "4", "♯5", "6"],
        squareNumbers: ["b2", "4", "6"],
      },
      ArrowDown: {
        x: 4,
        y: 1,
        prevDegree: "5.",
        name: "mixo",
        nameColor: "#FF7F00",
        degree: "b2",
        degreeColor: "#1e62ff",
        formulae: [1, 2, 5, 6, 8, 10, 11],
        formulaeOriginal: ["1", "2", "5", "6", "8", "0", "A"],
        numbers: ["1", "b2", "3", "4", "5", "6", "b7"],
        doubleUnderlineNumbers: ["b2", "5"],
        underlinedNumbers: ["3", "b7"],
        chromaticFormula: true,
      },
    },
    6: {
      ArrowUp: null,
      ArrowDown: {
        x: 4,
        y: 2,
        prevDegree: "5.",
        name: "phrygian",
        nameColor: "#1e62ff",
        degree: "♮3",
        degreeColor: "#ff7f00",
        formulae: [1, 2, 5, 6, 8, 9, 11],
        formulaeOriginal: ["1", "2", "5", "6", "8", "9", "A"],
        numbers: ["1", "b2", "3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["3", "b7"],
        doubleUnderlineNumbers: ["b2", "5"],
      },
    },
    7: {
      ArrowUp: {
        x: 4,
        y: 1,
        prevDegree: "5.",
        name: "mixo",
        nameColor: "#FF7F00",
        degree: "b2",
        degreeColor: "#1e62ff",
        formulae: [1, 2, 5, 6, 8, 10, 11],
        formulaeOriginal: ["1", "2", "5", "6", "8", "0", "A"],
        numbers: ["1", "b2", "3", "4", "5", "6", "b7"],
        doubleUnderlineNumbers: ["b2", "5"],
        underlinedNumbers: ["3", "b7"],
        chromaticFormula: true,
      },
      ArrowDown: null,
    },
  },
  "lydian ♯2 ♯5": {
    1: {
      ArrowUp: {
        x: 0,
        y: 2,
        prevDegree: "1.",
        name: "aeolian",
        nameColor: "#00FF00",
        degree: "♮7",
        degreeColor: "#FF0000",
        formulae: [1, 3, 4, 6, 8, 9, 12],
        formulaeOriginal: ["1", "3", "4", "6", "8", "9", "B"],
        numbers: ["1", "2", "b3", "4", "5", "b6", "7"],
        underlinedNumbers: ["4", "7"],
        doubleUnderlineNumbers: ["2", "b6"],
      },
      ArrowDown: null,
    },
    2: {
      ArrowUp: null,
      ArrowDown: {
        x: 2,
        y: 3,
        prevDegree: "b3.",
        name: "lydian",
        nameColor: "#fff",
        degree: "♯5",
        degreeColor: "#00FF00",
        // secondDegree: "♯5",
        // secondDegreeColor: "#fff",
        formulae: [1, 3, 5, 7, 9, 10, 12],
        formulaeOriginal: ["1", "3", "5", "7", "9", "0", "B"],
        numbers: ["1", "2", "3", "♯4", "♯5", "6", "7"],
        doubleUnderlineNumbers: ["1", "♯4"],
        underlinedNumbers: ["2", "♯5"],
      },
    },
    3: {
      ArrowUp: {
        x: 1,
        y: 0,
        name: "Whole/half",
        formulae: [1, 3, 4, 6, 7, 9, 10, 12],
        formulaeOriginal: ["1", "3", "4", "6", "7", "9", "0", "B"],
        numbers: ["1", "2", "b3", "4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["2", "b3", "b5", "b6", "bb7", "b8"],
        squareNumbers: ["2", "4", "b6", "b8"],
      },
      ArrowDown: null,
    },
    4: {
      ArrowUp: {
        x: 0,
        y: 1,
        nameColor: "#fff",
        degreeColor: "#fff",
        name: "Hexa",
        degree: "♯2",
        formulae: [1, 4, 5, 8, 9, 12],
        formulaeOriginal: ["1", "4", "5", "8", "9", "B"],
        numbers: ["1", "♯2", "3", "X4", "♯5", "X6"],
        squareNumbers: ["♯2", "X4", "X6"],
      },
      ArrowDown: {
        x: 5,
        y: 1,
        prevDegree: "b6.",
        name: "lydian",
        nameColor: "#FFFFFF",
        degree: "♯2",
        degreeColor: "#FFFF00",
        secondDegree: "♯5",
        secondDegreeColor: "#fff",
        formulae: [1, 4, 5, 7, 9, 10, 12],
        formulaeOriginal: ["1", "4", "5", "7", "9", "0", "B"],
        numbers: ["1", "♯2", "3", "♯4", "♯5", "6", "7"],
        doubleUnderlineNumbers: ["1", "♯4"],
        underlinedNumbers: ["♯2", "6"],
        chromaticFormula: true,
      },
    },
    5: {
      ArrowUp: null,
      ArrowDown: {
        x: 5,
        y: 2,
        prevDegree: "b6.",
        name: "lydian",
        nameColor: "#ff00b7",
        degree: "♯2",
        degreeColor: "#FFFF00",
        formulae: [1, 4, 5, 7, 8, 10, 12],
        formulaeOriginal: ["1", "4", "5", "7", "8", "0", "B"],
        numbers: ["1", "♯2", "3", "♯4", "5", "6", "7"],
        doubleUnderlineNumbers: ["1", "♯4"],
        underlinedNumbers: ["♯2", "6"],
      },
    },
    6: {
      ArrowUp: {
        x: 5,
        y: 1,
        prevDegree: "b6.",
        name: "lydian",
        nameColor: "#FFFFFF",
        degree: "♯2",
        degreeColor: "#FFFF00",
        secondDegree: "♯5",
        secondDegreeColor: "#fff",
        formulae: [1, 4, 5, 7, 9, 10, 12],
        formulaeOriginal: ["1", "4", "5", "7", "9", "0", "B"],
        numbers: ["1", "♯2", "3", "♯4", "♯5", "6", "7"],
        doubleUnderlineNumbers: ["1", "♯4"],
        underlinedNumbers: ["♯2", "6"],
        chromaticFormula: true,
      },
      ArrowDown: null,
    },
    7: {
      ArrowUp: null,
      ArrowDown: {
        x: 5,
        y: 1,
        prevDegree: "b6.",
        name: "lydian",
        nameColor: "#FFFFFF",
        degree: "♯2",
        degreeColor: "#FFFF00",
        secondDegree: "♯5",
        secondDegreeColor: "#fff",
        formulae: [1, 4, 5, 7, 9, 10, 12],
        formulaeOriginal: ["1", "4", "5", "7", "9", "0", "B"],
        numbers: ["1", "♯2", "3", "♯4", "♯5", "6", "7"],
        doubleUnderlineNumbers: ["1", "♯4"],
        underlinedNumbers: ["♯2", "6"],
        chromaticFormula: true,
      },
    },
  },
  "locrian bb7": {
    1: {
      ArrowUp: null,
      ArrowDown: {
        x: 3,
        y: 3,
        prevDegree: "4.",
        name: "lydian",
        nameColor: "#ff00b7",
        degree: "b7",
        degreeColor: "#FF7F00",
        formulae: [1, 3, 5, 7, 8, 10, 11],
        formulaeOriginal: ["1", "3", "5", "7", "8", "0", "A"],
        numbers: ["1", "2", "3", "♯4", "5", "6", "b7"],
        underlinedNumbers: ["1", "♯4"],
        doubleUnderlineNumbers: ["3", "b7"],
      },
    },
    2: {
      ArrowUp: {
        x: 1,
        y: 0,
        name: "Whole/half",
        formulae: [1, 3, 4, 6, 7, 9, 10, 12],
        formulaeOriginal: ["1", "3", "4", "6", "7", "9", "0", "B"],
        numbers: ["1", "2", "b3", "4", "b5", "bb6", "bb7", "bb8"],
        underlinedNumbers: ["2", "b3", "b5", "b6", "bb7", "b8"],
        squareNumbers: ["2", "4", "b6", "b8"],
      },
      ArrowDown: null,
    },
    3: {
      ArrowUp: {
        x: 0,
        y: 0,
        nameColor: "#fff",
        degreeColor: "#fff",
        name: "Hexa",
        degree: "b2",
        formulae: [1, 2, 5, 6, 9, 10],
        formulaeOriginal: ["1", "2", "5", "6", "9", "0"],
        numbers: ["1", "b2", "3", "4", "♯5", "6"],
        squareNumbers: ["b2", "4", "6"],
      },
      ArrowDown: {
        x: 6,
        y: 1,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#AE96FF",
        degree: "bb7",
        degreeColor: "#FFFF00",
        formulae: [1, 2, 4, 6, 7, 9, 10],
        formulaeOriginal: ["1", "2", "4", "6", "7", "9", "0"],
        numbers: ["1", "b2", "b3", "4", "b5", "b6", "bb7"],
        doubleUnderlineNumbers: ["b3", "bb7"],
        underlinedNumbers: ["1", "b5"],
        chromaticFormula: true,
      },
    },
    4: {
      ArrowUp: null,
      ArrowDown: {
        x: 6,
        y: 2,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#fff",
        degree: "b4",
        degreeColor: "#fff",
        secondDegree: "bb7",
        secondDegreeColor: "#FFFF00",
        text: "(Altered bb7)",
        formulae: [1, 2, 4, 5, 7, 9, 10],
        formulaeOriginal: ["1", "2", "4", "5", "7", "9", "0"],
        numbers: ["1", "b2", "b3", "b4", "b5", "b6", "bb7"],
        underlinedNumbers: ["1", "b5"],
        doubleUnderlineNumbers: ["b3", "bb7"],
      },
    },
    5: {
      ArrowUp: {
        x: 6,
        y: 1,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#AE96FF",
        degree: "bb7",
        degreeColor: "#FFFF00",
        formulae: [1, 2, 4, 6, 7, 9, 10],
        formulaeOriginal: ["1", "2", "4", "6", "7", "9", "0"],
        numbers: ["1", "b2", "b3", "4", "b5", "b6", "bb7"],
        doubleUnderlineNumbers: ["b3", "bb7"],
        underlinedNumbers: ["1", "b5"],
        chromaticFormula: true,
      },
      ArrowDown: null,
    },
    6: {
      ArrowUp: {
        x: 1,
        y: 2,
        prevDegree: "2.",
        name: "locrian",
        nameColor: "#AE96FF",
        degree: "♮6",
        degreeColor: "#FFFF00",
        formulae: [1, 2, 4, 6, 7, 10, 11],
        formulaeOriginal: ["1", "2", "4", "6", "7", "0", "A"],
        numbers: ["1", "b2", "b3", "4", "b5", "6", "b7"],
        doubleUnderlineNumbers: ["1", "b5"],
        underlinedNumbers: ["b3", "6"],
      },
      ArrowDown: {
        x: 6,
        y: 1,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#AE96FF",
        degree: "bb7",
        degreeColor: "#FFFF00",
        formulae: [1, 2, 4, 6, 7, 9, 10],
        formulaeOriginal: ["1", "2", "4", "6", "7", "9", "0"],
        numbers: ["1", "b2", "b3", "4", "b5", "b6", "bb7"],
        doubleUnderlineNumbers: ["b3", "bb7"],
        underlinedNumbers: ["1", "b5"],
        chromaticFormula: true,
      },
    },
    7: {
      ArrowUp: {
        x: 6,
        y: 0,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#AE96FF",
        formulae: [1, 2, 4, 6, 7, 9, 11],
        formulaeOriginal: ["1", "2", "4", "6", "7", "9", "A"],
        numbers: ["1", "b2", "b3", "4", "b5", "b6", "b7"],
        underlinedNumbers: ["1", "b5"],
      },
      ArrowDown: null,
    },
  },
};

const eightToneScaleChange = {
  "Half/whole": {
    1: {
      ArrowUp: null,
      ArrowDown: {
        x: 4,
        y: 3,
        prevDegree: "b5.",
        name: "mixo",
        nameColor: "#FF7F00",
        degree: "b6",
        degreeColor: "#00FF00",
        formulae: [1, 3, 5, 6, 8, 9, 11],
        formulaeOriginal: ["1", "3", "5", "6", "8", "9", "A"],
        numbers: ["1", "2", "3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["b7", "3"],
        doubleUnderlineNumbers: ["2", "b6"],
      },
    },
    2: {
      ArrowUp: {
        x: 3,
        y: 3,
        prevDegree: "4.",
        name: "lydian",
        nameColor: "#ff00b7",
        degree: "b7",
        degreeColor: "#FF7F00",
        formulae: [1, 3, 5, 7, 8, 10, 11],
        formulaeOriginal: ["1", "3", "5", "7", "8", "0", "A"],
        numbers: ["1", "2", "3", "♯4", "5", "6", "b7"],
        underlinedNumbers: ["1", "♯4"],
        doubleUnderlineNumbers: ["3", "b7"],
      },
      ArrowDown: null,
    },
    3: {
      ArrowUp: null,
      ArrowDown: {
        x: 3,
        y: 3,
        prevDegree: "4.",
        name: "lydian",
        nameColor: "#ff00b7",
        degree: "b7",
        degreeColor: "#FF7F00",
        formulae: [1, 3, 5, 7, 8, 10, 11],
        formulaeOriginal: ["1", "3", "5", "7", "8", "0", "A"],
        numbers: ["1", "2", "3", "♯4", "5", "6", "b7"],
        underlinedNumbers: ["1", "♯4"],
        doubleUnderlineNumbers: ["3", "b7"],
      },
    },
    4: {
      ArrowUp: {
        x: 1,
        y: 3,
        prevDegree: "2.",
        name: "dorian",
        nameColor: "#FFFF00",
        degree: "b2",
        degreeColor: "#1e62ff",
        formulae: [1, 2, 4, 6, 8, 10, 11],
        formulaeOriginal: ["1", "3", "4", "6", "8", "0", "B"],
        numbers: ["1", "2", "b3", "4", "b5", "6", "b7"],
        doubleUnderlineNumbers: ["2", "b5"],
        underlinedNumbers: ["b3", "6"],
      },
      ArrowDown: null,
    },
    5: {
      ArrowUp: null,
      ArrowDown: {
        x: 1,
        y: 3,
        prevDegree: "2.",
        name: "dorian",
        nameColor: "#FFFF00",
        degree: "b2",
        degreeColor: "#1e62ff",
        formulae: [1, 2, 4, 6, 8, 10, 11],
        formulaeOriginal: ["1", "3", "4", "6", "8", "0", "B"],
        numbers: ["1", "2", "b3", "4", "b5", "6", "b7"],
        doubleUnderlineNumbers: ["2", "b5"],
        underlinedNumbers: ["b3", "6"],
      },
    },
    6: {
      ArrowUp: {
        x: 6,
        y: 3,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#fff",
        degree: "b4",
        degreeColor: "#FF7F00",
        text: "(Altered Dominant)",
        formulae: [1, 2, 4, 5, 7, 9, 11],
        formulaeOriginal: ["1", "2", "4", "5", "7", "9", "A"],
        numbers: ["1", "b2", "b3", "b4", "b5", "b6", "b7"],
        underlinedNumbers: ["1", "b5"],
        doubleUnderlineNumbers: ["b4", "b7"],
      },
      ArrowDown: null,
    },
    7: {
      ArrowUp: null,
      ArrowDown: {
        x: 6,
        y: 3,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#fff",
        degree: "b4",
        degreeColor: "#FF7F00",
        text: "(Altered Dominant)",
        formulae: [1, 2, 4, 5, 7, 9, 11],
        formulaeOriginal: ["1", "2", "4", "5", "7", "9", "A"],
        numbers: ["1", "b2", "b3", "b4", "b5", "b6", "b7"],
        underlinedNumbers: ["1", "b5"],
        doubleUnderlineNumbers: ["b4", "b7"],
      },
    },
    8: {
      ArrowUp: {
        x: 4,
        y: 3,
        prevDegree: "5.",
        name: "mixo",
        nameColor: "#FF7F00",
        degree: "b6",
        degreeColor: "#00FF00",
        formulae: [1, 3, 5, 6, 8, 9, 11],
        formulaeOriginal: ["1", "3", "5", "6", "8", "9", "A"],
        numbers: ["1", "2", "3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["b7", "3"],
        doubleUnderlineNumbers: ["2", "b6"],
      },
      ArrowDown: null,
    },
  },
  "Whole/half": {
    1: {
      ArrowUp: {
        x: 4,
        y: 3,
        prevDegree: "b5.",
        name: "mixo",
        nameColor: "#FF7F00",
        degree: "b6",
        degreeColor: "#00FF00",
        formulae: [1, 3, 5, 6, 8, 9, 11],
        formulaeOriginal: ["1", "3", "5", "6", "8", "9", "A"],
        numbers: ["1", "2", "3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["b7", "3"],
        doubleUnderlineNumbers: ["2", "b6"],
      },
      ArrowDown: null,
    },
    2: {
      ArrowUp: null,
      ArrowDown: {
        x: 4,
        y: 3,
        prevDegree: "5.",
        name: "mixo",
        nameColor: "#FF7F00",
        degree: "b6",
        degreeColor: "#00FF00",
        formulae: [1, 3, 5, 6, 8, 9, 11],
        formulaeOriginal: ["1", "3", "5", "6", "8", "9", "A"],
        numbers: ["1", "2", "3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["b7", "3"],
        doubleUnderlineNumbers: ["2", "b6"],
      },
    },
    3: {
      ArrowUp: {
        x: 2,
        y: 3,
        prevDegree: "b3.",
        name: "lydian",
        nameColor: "#fff",
        degree: "♯5",
        degreeColor: "#00FF00",
        // secondDegree: "♯5",
        // secondDegreeColor: "#fff",
        formulae: [1, 3, 5, 7, 9, 10, 12],
        formulaeOriginal: ["1", "3", "5", "7", "9", "0", "B"],
        numbers: ["1", "2", "3", "♯4", "♯5", "6", "7"],
        doubleUnderlineNumbers: ["1", "♯4"],
        underlinedNumbers: ["2", "♯5"],
      },
      ArrowDown: null,
    },
    4: {
      ArrowUp: null,
      ArrowDown: {
        x: 2,
        y: 3,
        prevDegree: "b3.",
        name: "lydian",
        nameColor: "#fff",
        degree: "♯5",
        degreeColor: "#00FF00",
        // secondDegree: "♯5",
        // secondDegreeColor: "#fff",
        formulae: [1, 3, 5, 7, 9, 10, 12],
        formulaeOriginal: ["1", "3", "5", "7", "9", "0", "B"],
        numbers: ["1", "2", "3", "♯4", "♯5", "6", "7"],
        doubleUnderlineNumbers: ["1", "♯4"],
        underlinedNumbers: ["2", "♯5"],
      },
    },
    5: {
      ArrowUp: {
        x: 0,
        y: 3,
        prevDegree: "1.",
        name: "ionian",
        nameColor: "#FF0000",
        degree: "b3",
        degreeColor: "#FFFF00",
        formulae: [1, 3, 4, 6, 8, 10, 12],
        formulaeOriginal: ["1", "3", "4", "6", "8", "0", "B"],
        numbers: ["1", "2", "b3", "4", "5", "6", "7"],
        doubleUnderlineNumbers: ["b3", "6"],
        underlinedNumbers: ["4", "7"],
      },
      ArrowDown: null,
    },
    6: {
      ArrowUp: null,
      ArrowDown: {
        x: 0,
        y: 3,
        prevDegree: "1.",
        name: "ionian",
        nameColor: "#FF0000",
        degree: "b3",
        degreeColor: "#FFFF00",
        formulae: [1, 3, 4, 6, 8, 10, 12],
        formulaeOriginal: ["1", "3", "4", "6", "8", "0", "B"],
        numbers: ["1", "2", "b3", "4", "5", "6", "7"],
        doubleUnderlineNumbers: ["b3", "6"],
        underlinedNumbers: ["4", "7"],
      },
    },
    7: {
      ArrowUp: {
        x: 5,
        y: 3,
        prevDegree: "6.",
        name: "aeolian",
        nameColor: "#AE96FF",
        degree: "b5",
        degreeColor: "#00FF00",
        formulae: [1, 3, 4, 6, 7, 9, 11],
        formulaeOriginal: ["1", "3", "4", "6", "7", "9", "A"],
        numbers: ["1", "2", "b3", "4", "b5", "b6", "b7"],
        doubleUnderlineNumbers: ["1", "b5"],
        underlinedNumbers: ["2", "b6"],
      },
      ArrowDown: null,
    },
    8: {
      ArrowUp: null,
      ArrowDown: {
        x: 5,
        y: 3,
        prevDegree: "6.",
        name: "aeolian",
        nameColor: "#AE96FF",
        degree: "b5",
        degreeColor: "#00FF00",
        formulae: [1, 3, 4, 6, 7, 9, 11],
        formulaeOriginal: ["1", "3", "4", "6", "7", "9", "A"],
        numbers: ["1", "2", "b3", "4", "b5", "b6", "b7"],
        doubleUnderlineNumbers: ["1", "b5"],
        underlinedNumbers: ["2", "b6"],
      },
    },
  },
};
const sixToneScaleChange = {
  "Whole Tones": {
    1: {
      ArrowUp: {
        x: 1,
        y: 3,
        prevDegree: "2.",
        name: "dorian",
        nameColor: "#FFFF00",
        degree: "b2",
        degreeColor: "#1e62ff",
        formulae: [1, 2, 4, 6, 8, 10, 11],
        formulaeOriginal: ["1", "3", "4", "6", "8", "0", "B"],
        numbers: ["1", "2", "b3", "4", "b5", "6", "b7"],
        doubleUnderlineNumbers: ["2", "b5"],
        underlinedNumbers: ["b3", "6"],
      },
      ArrowDown: {
        x: 0,
        y: 3,
        prevDegree: "1.",
        name: "ionian",
        nameColor: "#FF0000",
        degree: "b3",
        degreeColor: "#FFFF00",
        formulae: [1, 3, 4, 6, 8, 10, 12],
        formulaeOriginal: ["1", "3", "4", "6", "8", "0", "B"],
        numbers: ["1", "2", "b3", "4", "5", "6", "7"],
        doubleUnderlineNumbers: ["b3", "6"],
        underlinedNumbers: ["4", "7"],
      },
    },
    2: {
      ArrowUp: {
        x: 6,
        y: 3,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#fff",
        degree: "b4",
        degreeColor: "#FF7F00",
        text: "(Altered Dominant)",
        formulae: [1, 2, 4, 5, 7, 9, 11],
        formulaeOriginal: ["1", "2", "4", "5", "7", "9", "A"],
        numbers: ["1", "b2", "b3", "b4", "b5", "b6", "b7"],
        underlinedNumbers: ["1", "b5"],
        doubleUnderlineNumbers: ["b4", "b7"],
      },
      ArrowDown: {
        x: 6,
        y: 3,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#fff",
        degree: "b4",
        degreeColor: "#FF7F00",
        text: "(Altered Dominant)",
        formulae: [1, 2, 4, 5, 7, 9, 11],
        formulaeOriginal: ["1", "2", "4", "5", "7", "9", "A"],
        numbers: ["1", "b2", "b3", "b4", "b5", "b6", "b7"],
        underlinedNumbers: ["1", "b5"],
        doubleUnderlineNumbers: ["b4", "b7"],
      },
    },
    3: {
      ArrowUp: {
        x: 5,
        y: 3,
        prevDegree: "6.",
        name: "aeolian",
        nameColor: "#AE96FF",
        degree: "b5",
        degreeColor: "#00FF00",
        formulae: [1, 3, 4, 6, 7, 9, 11],
        formulaeOriginal: ["1", "3", "4", "6", "7", "9", "A"],
        numbers: ["1", "2", "b3", "4", "b5", "b6", "b7"],
        doubleUnderlineNumbers: ["1", "b5"],
        underlinedNumbers: ["2", "b6"],
      },
      ArrowDown: {
        x: 5,
        y: 3,
        prevDegree: "6.",
        name: "aeolian",
        nameColor: "#AE96FF",
        degree: "b5",
        degreeColor: "#00FF00",
        formulae: [1, 3, 4, 6, 7, 9, 11],
        formulaeOriginal: ["1", "3", "4", "6", "7", "9", "A"],
        numbers: ["1", "2", "b3", "4", "b5", "b6", "b7"],
        doubleUnderlineNumbers: ["1", "b5"],
        underlinedNumbers: ["2", "b6"],
      },
    },
    4: {
      ArrowUp: {
        x: 4,
        y: 3,
        prevDegree: "b5.",
        name: "mixo",
        nameColor: "#FF7F00",
        degree: "b6",
        degreeColor: "#00FF00",
        formulae: [1, 3, 5, 6, 8, 9, 11],
        formulaeOriginal: ["1", "3", "5", "6", "8", "9", "A"],
        numbers: ["1", "2", "3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["b7", "3"],
        doubleUnderlineNumbers: ["2", "b6"],
      },
      ArrowDown: {
        x: 4,
        y: 3,
        prevDegree: "b5.",
        name: "mixo",
        nameColor: "#FF7F00",
        degree: "b6",
        degreeColor: "#00FF00",
        formulae: [1, 3, 5, 6, 8, 9, 11],
        formulaeOriginal: ["1", "3", "5", "6", "8", "9", "A"],
        numbers: ["1", "2", "3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["b7", "3"],
        doubleUnderlineNumbers: ["2", "b6"],
      },
    },
    5: {
      ArrowUp: {
        x: 3,
        y: 3,
        prevDegree: "4.",
        name: "lydian",
        nameColor: "#ff00b7",
        degree: "b7",
        degreeColor: "#FF7F00",
        formulae: [1, 3, 5, 7, 8, 10, 11],
        formulaeOriginal: ["1", "3", "5", "7", "8", "0", "A"],
        numbers: ["1", "2", "3", "♯4", "5", "6", "b7"],
        underlinedNumbers: ["1", "♯4"],
        doubleUnderlineNumbers: ["3", "b7"],
      },
      ArrowDown: {
        x: 3,
        y: 3,
        prevDegree: "4.",
        name: "lydian",
        nameColor: "#ff00b7",
        degree: "b7",
        degreeColor: "#FF7F00",
        formulae: [1, 3, 5, 7, 8, 10, 11],
        formulaeOriginal: ["1", "3", "5", "7", "8", "0", "A"],
        numbers: ["1", "2", "3", "♯4", "5", "6", "b7"],
        underlinedNumbers: ["1", "♯4"],
        doubleUnderlineNumbers: ["3", "b7"],
      },
    },
    6: {
      ArrowUp: {
        x: 2,
        y: 3,
        prevDegree: "b3.",
        name: "lydian",
        nameColor: "#fff",
        degree: "♯5",
        degreeColor: "#00FF00",
        // secondDegree: "♯5",
        // secondDegreeColor: "#fff",
        formulae: [1, 3, 5, 7, 9, 10, 12],
        formulaeOriginal: ["1", "3", "5", "7", "9", "0", "B"],
        numbers: ["1", "2", "3", "♯4", "♯5", "6", "7"],
        doubleUnderlineNumbers: ["1", "♯4"],
        underlinedNumbers: ["2", "♯5"],
      },
      ArrowDown: {
        x: 2,
        y: 3,
        prevDegree: "b3.",
        name: "lydian",
        nameColor: "#fff",
        degree: "♯5",
        degreeColor: "#00FF00",
        // secondDegree: "♯5",
        // secondDegreeColor: "#fff",
        formulae: [1, 3, 5, 7, 9, 10, 12],
        formulaeOriginal: ["1", "3", "5", "7", "9", "0", "B"],
        numbers: ["1", "2", "3", "♯4", "♯5", "6", "7"],
        doubleUnderlineNumbers: ["1", "♯4"],
        underlinedNumbers: ["2", "♯5"],
      },
    },
  },
  "Hexa b2": {
    1: {
      ArrowUp: null,
      ArrowDown: {
        x: 1,
        y: 1,
        prevDegree: "2.",
        name: "dorian",
        nameColor: "#FFFF00",
        degree: "b5",
        degreeColor: "#1e62ff",
        formulae: [1, 3, 4, 6, 7, 10, 11],
        formulaeOriginal: ["1", "3", "4", "6", "7", "0", "A"],
        numbers: ["1", "2", "b3", "4", "b5", "6", "b7"],
        doubleUnderlineNumbers: ["1", "b5"],
        underlinedNumbers: ["b3", "6"],
      },
    },
    2: {
      ArrowUp: {
        x: 2,
        y: 2,
        prevDegree: "b3.",
        name: "ionian",
        nameColor: "#FF0000",
        degree: "♯5",
        degreeColor: "#00FF00",
        formulae: [1, 3, 5, 6, 9, 10, 12],
        formulaeOriginal: ["1", "3", "5", "6", "9", "0", "B"],
        numbers: ["1", "2", "3", "4", "♯5", "6", "7"],
        doubleUnderlineNumbers: ["4", "7"],
        underlinedNumbers: ["2", "♯5"],
      },
      ArrowDown: null,
    },
    3: {
      ArrowUp: null,
      ArrowDown: {
        x: 6,
        y: 1,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#AE96FF",
        degree: "bb7",
        degreeColor: "#FFFF00",
        formulae: [1, 2, 4, 6, 7, 9, 10],
        formulaeOriginal: ["1", "2", "4", "6", "7", "9", "0"],
        numbers: ["1", "b2", "b3", "4", "b5", "b6", "bb7"],
        doubleUnderlineNumbers: ["b3", "bb7"],
        underlinedNumbers: ["1", "b5"],
      },
    },
    4: {
      ArrowUp: {
        x: 6,
        y: 2,
        prevDegree: "7.",
        name: "locrian",
        nameColor: "#fff",
        degree: "b4",
        degreeColor: "#fff",
        secondDegree: "bb7",
        secondDegreeColor: "#FFFF00",
        text: "(Altered bb7)",
        formulae: [1, 2, 4, 5, 7, 9, 10],
        formulaeOriginal: ["1", "2", "4", "5", "7", "9", "0"],
        numbers: ["1", "b2", "b3", "b4", "b5", "b6", "bb7"],
        underlinedNumbers: ["1", "b5"],
        doubleUnderlineNumbers: ["b3", "bb7"],
      },
      ArrowDown: null,
    },
    5: {
      ArrowUp: null,
      ArrowDown: {
        x: 4,
        y: 1,
        prevDegree: "5.",
        name: "mixo",
        nameColor: "#FF7F00",
        degree: "b2",
        degreeColor: "#1e62ff",
        formulae: [1, 2, 5, 6, 8, 10, 11],
        formulaeOriginal: ["1", "2", "5", "6", "8", "0", "A"],
        numbers: ["1", "b2", "3", "4", "5", "6", "b7"],
        doubleUnderlineNumbers: ["b2", "5"],
        underlinedNumbers: ["3", "b7"],
      },
    },
    6: {
      ArrowUp: {
        x: 4,
        y: 2,
        prevDegree: "5.",
        name: "phrygian",
        nameColor: "#1e62ff",
        degree: "♮3",
        degreeColor: "#ff7f00",
        formulae: [1, 2, 5, 6, 8, 9, 11],
        formulaeOriginal: ["1", "2", "5", "6", "8", "9", "A"],
        numbers: ["1", "b2", "3", "4", "5", "b6", "b7"],
        underlinedNumbers: ["3", "b7"],
        doubleUnderlineNumbers: ["b2", "5"],
      },
      ArrowDown: null,
    },
  },
  "Hexa ♯2": {
    1: {
      ArrowUp: {
        x: 3,
        y: 2,
        prevDegree: "4.",
        name: "dorian",
        nameColor: "#FFFF00",
        degree: "♯4",
        degreeColor: "#ff00b7",
        formulae: [1, 3, 4, 7, 8, 10, 11],
        formulaeOriginal: ["1", "3", "4", "7", "8", "0", "A"],
        numbers: ["1", "2", "b3", "♯4", "5", "6", "b7"],
        underlinedNumbers: ["1", "♯4"],
        doubleUnderlineNumbers: ["b3", "6"],
      },
      ArrowDown: null,
    },
    2: {
      ArrowUp: null,
      ArrowDown: {
        x: 0,
        y: 1,
        prevDegree: "1.",
        name: "ionian",
        nameColor: "#FF0000",
        degree: "b6",
        degreeColor: "#00FF00",
        formulae: [1, 3, 5, 6, 8, 9, 12],
        formulaeOriginal: ["1", "3", "5", "6", "8", "9", "B"],
        numbers: ["1", "2", "3", "4", "5", "b6", "7"],
        doubleUnderlineNumbers: ["2", "b6"],
        underlinedNumbers: ["4", "7"],
      },
    },
    3: {
      ArrowUp: {
        x: 0,
        y: 2,
        prevDegree: "1.",
        name: "aeolian",
        nameColor: "#00FF00",
        degree: "♮7",
        degreeColor: "#FF0000",
        formulae: [1, 3, 4, 6, 8, 9, 12],
        formulaeOriginal: ["1", "3", "4", "6", "8", "9", "B"],
        numbers: ["1", "2", "b3", "4", "5", "b6", "7"],
        underlinedNumbers: ["4", "7"],
        doubleUnderlineNumbers: ["2", "b6"],
      },
      ArrowDown: null,
    },
    4: {
      ArrowUp: null,
      ArrowDown: {
        x: 5,
        y: 1,
        prevDegree: "b6.",
        name: "lydian",
        nameColor: "#FFFFFF",
        degree: "♯2",
        degreeColor: "#FFFF00",
        secondDegree: "♯5",
        secondDegreeColor: "#fff",
        formulae: [1, 4, 5, 7, 9, 10, 12],
        formulaeOriginal: ["1", "4", "5", "7", "9", "0", "B"],
        numbers: ["1", "♯2", "3", "♯4", "♯5", "6", "7"],
        doubleUnderlineNumbers: ["1", "♯4"],
        underlinedNumbers: ["♯2", "6"],
      },
    },
    5: {
      ArrowUp: {
        x: 5,
        y: 2,
        prevDegree: "b6.",
        name: "lydian",
        nameColor: "#ff00b7",
        degree: "♯2",
        degreeColor: "#FFFF00",
        formulae: [1, 4, 5, 7, 8, 10, 12],
        formulaeOriginal: ["1", "4", "5", "7", "8", "0", "B"],
        numbers: ["1", "♯2", "3", "♯4", "5", "6", "7"],
        doubleUnderlineNumbers: ["1", "♯4"],
        underlinedNumbers: ["♯2", "6"],
      },
      ArrowDown: null,
    },
    6: {
      ArrowUp: null,
      ArrowDown: {
        x: 2,
        y: 1,
        prevDegree: "3.",
        name: "phrygian",
        nameColor: "#1e62ff",
        degree: "b4",
        degreeColor: "#FF7F00",
        formulae: [1, 2, 4, 5, 8, 9, 11],
        formulaeOriginal: ["1", "2", "4", "5", "8", "9", "A"],
        numbers: ["1", "b2", "b3", "b4", "5", "b6", "b7"],
        underlinedNumbers: ["b2", "5"],
        doubleUnderlineNumbers: ["b4", "b7"],
      },
    },
  },
};
export { sevenToneScaleChange, eightToneScaleChange, sixToneScaleChange };
